export default class ContentConstants {
	public static readonly DISTRIBUTIONUPLOAD_APPEND_DISABLEDTEMPORARILY = `<strong>PLEASE NOTE</strong>: The ability to
		append files is temporarily unavailable. Please contact your administrator for steps on the recommended workaround.`;

	// MISC
	public static readonly COLUMNPICKER_TITLE = 'Columns';
	public static readonly DATA_TRANSFER = 'Data Transfer';
	public static readonly EMPTY_PLACEHOLDER = '--';
	public static readonly ENABLE_HTML = 'Enable HTML content';
	public static readonly ERROR_OCCURRED = 'an error occurred';
	public static readonly ERROR = 'Error';
	public static readonly ERROR_CAPS = 'ERROR';
	public static readonly SURVEY_MIN_N = 'Anonymity Threshold';
	public static readonly CLIENT_MIN_N = 'Client Default Anonymity Threshold';
	public static readonly NO_VALUE = 'No value';
	public static readonly NOT_AVAILABLE = 'NOT AVAILABLE:';
	public static readonly NOTE = 'Note';
	public static readonly OF = 'of';
	public static readonly OPTIONAL_WITH_PARENS = '(Optional)';
	public static readonly REFERENCE_ONLY_MESSAGE = 'This name is for your reference only.';
	public static readonly SAVED = 'Saved';
	public static readonly UNSAVED_CHANGES = 'Unsaved Changes';
	public static readonly WARNING = 'Warning';
	public static readonly NO = 'No';
	public static readonly YES = 'Yes';
	public static readonly YES_TRANSFER_DATA = 'Yes, Transfer the Data';
	public static readonly NO_TRANSFER_DATA = "No, Don't transfer Data";
	public static readonly WARNING_STRONG = '<strong>WARNING:</strong>';
	public static readonly POSITION = 'Position';
	public static readonly EMAIL_ADDRESS = 'Email Address';
	public static readonly EVENTS = 'Events';
	public static readonly SURVEY = 'survey';
	public static readonly EVENT = 'event';

	// PAGE TITLES
	public static readonly TITLE_INITIAL_SURVEY_SETUP = 'Initial Survey Setup';
	public static readonly TITLE_DESIGN_YOUR_SURVEY = 'Design Your Survey';
	public static readonly TITLE_DEFINE_SURVEY_CONTENT = 'Define Survey Content';
	public static readonly TITLE_SURVEY_QUESTIONS = 'Survey Questions';
	public static readonly TITLE_CUSTOM_SURVEY_QUESTIONS = 'Custom Survey Questions';
	public static readonly TITLE_MANAGE_SURVEY_DIMENSIONS = 'Manage Survey Dimensions';
	public static readonly TITLE_CREATE_SURVEY_DIMENSIONS = 'Create Survey Dimensions';
	public static readonly TITLE_DEMOGRAPHIC_QUESTIONS = 'Demographic Questions';
	public static readonly TITLE_CUSTOM_DEMOGRAPHIC_QUESTIONS = 'Custom Demographic Questions';
	public static readonly TITLE_CREATE_SURVEY_QUESTION = 'Create Survey Question';
	public static readonly TITLE_UPDATE_SURVEY_QUESTION = 'Update Survey Question';
	public static readonly TITLE_CREATE_CUSTOM_DIMENSION = 'Create Dimension';
	public static readonly TITLE_EDIT_CUSTOM_DIMENSION = 'Edit Dimension';
	public static readonly TITLE_CREATE_DEMOGRAPHIC_QUESTION = 'Create Demographic Question';
	public static readonly TITLE_UPDATE_DEMOGRAPHIC_QUESTION = 'Update Demographic Question';
	public static readonly TITLE_SURVEY_SUMMARY = 'Survey Summary';
	public static readonly TITLE_PUBLISH_TO_MRESEARCH = 'Publish To mResearch';
	public static readonly TITLE_TRANSLATION_EDITOR = 'Translation Editor';
	public static readonly TITLE_SCHEDULING_IN_PROGRESS = 'Scheduling in Progress';
	public static readonly TITLE_SYNCING_IN_PROGRESS = 'Survey Edit Sync in Progress';
	public static readonly TITLE_REPORTING_SETUP = 'Setup Survey Reporting';
	public static readonly TITLE_REMINDER_EMAIL_READONLY = 'Reminder Email (Read only)';
	public static readonly TITLE_REMINDER_EMAIL_ADD = 'Add Reminder Email';
	public static readonly TITLE_REMINDER_EMAIL_EDIT = 'Edit Reminder Email';
	public static readonly TITLE_MOVE_QUESTIONS = 'Move Questions';
	public static readonly TITLE_COPY_QUESTIONS = 'Copy Questions';

	// SURVEY STEPPER
	public static readonly STEPPER_SIDEPAD_HEADERTEXT = 'Steps';
	public static readonly STEPPER_SIDEPAD_TITLETEXT = 'Survey name';
	public static readonly STEPPER_STEP_BASICS = 'Initial survey setup';
	public static readonly STEPPER_STEP_DEFINE = 'Define survey content';
	public static readonly STEPPER_STEP_DESIGN_YOUR_SURVEY = 'Design your survey';
	public static readonly STEPPER_STEP_BRANDING_AND_THEME = 'Branding and Theme';
	public static readonly STEPPER_STEP_LOGIC_AND_LAYOUT = 'Logic and Layout';
	public static readonly STEPPER_STEP_DISTRIBUTION = 'Distribute your survey';
	public static readonly STEPPER_STEP_REPORTING = 'Setup survey reporting';
	public static readonly STEPPER_STEP_CONFIRM = 'Confirm and schedule';
	public static readonly STEPPER_STEP_DEFINE_BASICS = 'General';
	public static readonly STEPPER_STEP_DEFINE_QUESTIONS = 'Add questions';
	public static readonly STEPPER_STEP_MANAGE_DIMENSIONS = 'Manage Dimensions';

	// SECTION HEADERS
	public static readonly SECTIONHEADERS_AUDIENCE_BASICS = 'Audience Basics';
	public static readonly SECTIONHEADERS_AUDIENCE_OPEN_CLOSE_DATES = 'Audience Open/Close Dates';
	public static readonly SECTIONHEADERS_BENCHMARKS = 'Choose Comparison Benchmark';
	public static readonly SECTIONHEADERS_CUSTOM_DIMENSION_NAME_AND_TRANSLATIONS = 'Dimension Name & Translations';
	public static readonly SECTIONHEADERS_CUSTOM_DIMENSION_QUESTIONS = 'Add Questions (Select at least one question)';
	public static readonly SECTIONHEADERS_CUSTOM_DIMENSION_MODAL_NAME_AND_TRANSLATIONS = 'Name And Translations';
	public static readonly SECTIONHEADERS_CUSTOM_DIMENSION_MODAL_DIMENSION_INFO = 'Dimension Info';
	public static readonly SECTIONHEADERS_CUSTOM_QUESTION_ADD = 'Add A Question';
	public static readonly SECTIONHEADERS_CUSTOM_QUESTION_CHOOSE_RESPONSEOPTION = 'Choose A Response Option';
	public static readonly SECTIONHEADERS_CUSTOM_QUESTION_CREATE_RESPONSEOPTION = 'Create A Response Option';
	public static readonly SECTIONHEADERS_DEMOGRAPHIC_QUESTIONS = 'Demographic Questions';
	public static readonly SECTIONHEADERS_DISTRIBUTION_OPTIONS = 'Distribution Options For Your Audience';
	public static readonly SECTIONHEADERS_EMPLOYEE_DATA_SOURCE = 'Employee Data Source';
	public static readonly SECITONHEADERS_ERRORS_AND_WARNINGS = 'Errors and Warnings';
	public static readonly SECTIONHEADERS_MANAGE_DIMENSIONS = 'Manage Dimensions';
	public static readonly SECTIONHEADERS_PARTICIPATION_MONITOR_ATTRIBUTE = 'Participation Monitor Breakout Selections';
	public static readonly SECTIONHEADERS_REPORTING_APPLICATION = 'Reporting Application';
	public static readonly SECTIONHEADERS_REPORTING_HIERARCHY_SELECTION = 'Select Hierarchies for Reporting';
	public static readonly SECTIONHEADERS_REPORTING_PROFILES = 'Reporting Site User Profiles';
	public static readonly SECTIONHEADERS_REPORTING_SETUP_BENCHMARKS = 'Confirm Benchmarks For Reporting';
	public static readonly SECTIONHEADERS_REPORTING_SETUP_TRENDS = 'Trend Your Results';
	public static readonly SECTIONHEADERS_REPORTING_SETUP_TRENDS_READ_ONLY = 'Trend Your Results (Read Only)';
	public static readonly SECTIONHEADERS_REPORTING_SETUP_USERS = 'Add Reporting Site Users';
	public static readonly SECTIONHEADERS_RESPONSE_STREAM = 'Stream Survey Responses';
	public static readonly SECTIONHEADERS_SURVEY_AUDIENCE_LIST = 'Survey Audience List';
	public static readonly SECTIONHEADERS_SURVEY_BASICS = 'Survey Basics';
	public static readonly SECTIONHEADERS_SURVEY_CONTENT = 'Survey Content';
	public static readonly SECTIONHEADERS_SURVEY_QUESTIONS = 'Questions';
	public static readonly SECTIONHEADERS_SURVEY_TEXTTOSPEECH_INSTRUCTIONS = 'Text As Audio Instructions';
	public static readonly SECTIONHEADERS_SURVEY_PRIVACYPOLICY_CONTENT_PLACEHOLDER = 'Add the Kincentric Privacy Policy or Build your Own';
	public static readonly SECTIONHEADERS_SURVEY_BRANDING_AND_THEME = 'Branding and Theme';
	public static readonly SECTIONHEADERS_SURVEY_LOGIC_AND_LAYOUT = 'Logic and Layout';
	public static readonly SECTIONHEADERS_SURVEY_GENERAL = 'General';
	public static readonly SECTIONHEADERS_PUBLISH_DESTINATION = 'Publish Destination';

	// SUB_SECTION HEADERS
	public static readonly SUBSECTIONHEADERS_SURVEY_NAME = 'Survey Name';
	public static readonly SUBSECTIONHEADERS_LANGUAGES = 'Enabled Languages';
	public static readonly SUBSECTIONHEADERS_DEFAULT_LANGUAGE = 'Default Language';
	public static readonly SUBSECTIONHEADERS_ADDITIONAL_LANGUAGES = 'Additional Languages';
	public static readonly SUBSECTIONHEADERS_TEXTTOSPEECH = 'Text As Audio';
	public static readonly SUBSECTIONHEADERS_BENCHMARKS = 'Enabled Benchmarks';
	public static readonly SUBSECTIONHEADERS_EMPLOYEE_DATA_SOURCE = 'Choose Your Employee Data Source and File';
	public static readonly SUBSECTIONHEADERS_PUBLISH_DESTINATION = 'Choose Your Publish Destination';
	public static readonly SUBSECTIONHEADERS_REPORTING_APPLICATION = 'Choose Application';
	public static readonly SUBSECTIONHEADERS_SURVEY_LOGO = 'Client Logo';
	public static readonly SUBSECTIONHEADERS_SURVEY_LOGO_NAME = 'Client Logo Name';
	public static readonly SUBSECTIONHEADERS_SURVEY_LOGO_PLACEMENT = 'Client Logo Placement';
	public static readonly SUBSECTIONHEADERS_SURVEY_KINCENTRIC_LOGO = 'Kincentric Logo';
	public static readonly SUBSECTIONHEADERS_SURVEY_TYPE = 'Choose Survey Types';
	public static readonly SUBSECTIONHEADERS_SURVEYTITLE = 'Survey Title';
	public static readonly SUBSECTIONHEADERS_SURVEYINTRO = 'Survey Intro';
	public static readonly SUBSECTIONHEADERS_SURVEYINSTRUCTIONS = 'Survey Instructions';
	public static readonly SUBSECTIONHEADERS_PRIVACYPOLICY = 'Privacy Policy';
	public static readonly SUBSECTIONHEADERS_PRIVACYPOLICYTITLE = 'Privacy Policy Title';
	public static readonly SUBSECTIONHEADERS_PRIVACYPOLICYCONTENT = 'Privacy Policy Content';
	public static readonly SUBSECTIONHEADERS_PRIVACYPOLICYCHECKBOXTEXT = 'Privacy Policy CheckBox Text';
	public static readonly SUBSECTIONHEADERS_TITLE = 'Title';
	public static readonly SUBSECTIONHEADERS_CONTENT = 'Content';
	public static readonly SUBSECTIONHEADERS_CHECKBOXTEXT = 'Checkbox Text';
	public static readonly SUBSECTIONHEADERS_SURVEYERRORS = 'Survey Errors';
	public static readonly SUBSECTIONHEADERS_SURVEYWARNINGS = 'Survey Warnings';
	public static readonly SUBSECTIONHEADERS_QUESTIONTEXT = 'Question Text';
	public static readonly SUBSECTIONHEADERS_QUESTIONTRANSLATIONS = 'Question Translations';
	public static readonly SUBSECTIONHEADERS_DIMENSION_INDEX = 'Dimension/Index';
	public static readonly SUBSECTIONHEADERS_DIMENSION_NAME = 'Dimension Name';
	public static readonly SUBSECTIONHEADERS_DIMENSION_TRANSLATIONS = 'Add Translations';
	public static readonly SUBSECTIONHEADERS_DIMENSION_TYPE = 'Type';
	public static readonly SUBSECTIONHEADERS_DIMENSION_IS_SCORED = 'Is Scored';
	public static readonly SUBSECTIONHEADERS_DIMENSION_RESPONSE_OPTION = 'Response Option';
	public static readonly SUBSECTIONHEADERS_INSTRUCTIONS = 'Instructions';
	public static readonly SUBSECTIONHEADERS_PARTICIPATION_MONITOR_ATTRIBUTE = 'Attributes Available For Breakouts';
	public static readonly SUBSECTIONHEADERS_PARTICIPATION_MONITOR_HIERARCHY = 'Hierarchies Available For Breakouts';
	public static readonly SUBSECTIONHEADERS_REPORTING_HIERARCHY_SELECTION = 'Hierarchies Available For Reporting';
	public static readonly SUBSECTIONHEADERS_REPORTING_ACCESS = 'Reporting Access';
	public static readonly SUBSECTIONHEADERS_REPORTING_MIN_N = 'Anonymity Threshold';
	public static readonly SUBSECTIONHEADERS_REPORTING_TREND = 'Chosen Trend Group';
	public static readonly SUBSECTIONHEADERS_REPORTING_REPORTING_USERS_INDIVIDUALLY = 'Reporting Users - Individually';
	public static readonly SUBSECTIONHEADERS_REPORTING_REPORTING_USERS_BULK = 'Reporting Users - Bulk';
	public static readonly SUBSECTIONHEADERS_SURVEY_PROGRESS_METER = 'Progress Meter';
	public static readonly SUBSECTIONHEADERS_QUESTION_NUMBERING = 'Include Question Numbering';
	public static readonly SUBSECTIONHEADERS_SURVEY_DEFINITIONS = 'Survey Definitions';
	public static readonly SUBSECTIONHEADERS_SURVEY_DEFINITIONS_PAGE_DESCRIPTION = 'Page Description';
	public static readonly SUBSECTIONHEADERS_SURVEY_DEFINITION_TERM = 'Survey Definition Column 1';
	public static readonly SUBSECTIONHEADERS_SURVEY_DEFINITION_DESC = 'Survey Definition Column 2';
	public static readonly INPUTLABEL_SURVEY_DEFINITIONS =
		'Add framing around your survey with definitions that will anchor employees in the appropriate context.';
	public static readonly SUBSECTIONHEADERS_SURVEY_THEME_PRESETS = 'Theme';
	public static readonly SUBSECTIONHEADERS_SURVEY_THEME_COLOR = 'Color';
	public static readonly SUBSECTIONHEADERS_SURVEY_THEME_PRIMARY_COLOR = 'Primary';
	public static readonly SUBSECTIONHEADERS_SURVEY_THEME_BACKGROUND_COLOR = 'Background';
	public static readonly SUBSECTIONHEADERS_SURVEY_THEME_BUTTONS = 'Buttons';
	public static readonly SUBSECTIONHEADERS_SURVEY_THEME_PRIMARY_BUTTON = 'Primary';
	public static readonly SUBSECTIONHEADERS_SURVEY_THEME_SECONDARY_BUTTON = 'Secondary';
	public static readonly SUBSECTIONHEADERS_SURVEY_THEME_BUTTON_COLOR = 'Color';
	public static readonly SUBSECTIONHEADERS_SURVEY_THEME_BUTTON_TEXT_COLOR = 'Text Color';

	// SECTION DESCRIPTION BLOCKS
	public static readonly SECTION_DESCRIPTION_LANGUAGES = 'Add languages to make your survey available in.';
	public static readonly SECTION_DESCRIPTION_DEFAULT_LANGUAGE = 'Choose the default language for the survey.';
	public static readonly SECTION_DESCRIPTION_ADDITIONAL_LANGUAGES = 'Choose additional languages that you want your survey to appear in.';
	public static readonly SECTION_DESCRIPTION_TEXTTOSPEECH = 'Enables the text on your survey to be read as audio to survey takers.';
	public static readonly SECTION_DESCRIPTION_BENCHMARKS =
		'Select benchmarks to put your survey ' +
		'data into context. We have a large array of benchmarks to choose from, including location-specific and ' +
		"industry-specific scores. <strong>And don't worry...your decisions aren't final.</strong> You can " +
		'change your selections later. Survey benchmarks are based on a 3-year rolling set of Kincentric client data, ' +
		'and are weighted to reflect the global or regional workforce as appropriate.';
	public static readonly SECTION_DESCRIPTION_EMPLOYEE_DATA_SOURCE =
		'Select where your employee data, ' +
		'like employee attributes (EX: gender) and employee hierarchies, comes from. This will be the definitive ' +
		'source of data about your employees for this survey';
	public static readonly SECTION_DESCRIPTION_PUBLISH_DESTINATION = 'Select where your survey will be published to.';
	public static readonly SECTION_DESCRIPTION_REPORTING_APPLICATION =
		'Select the application you would like to send your results to. You will not be able to make any changes after you save the selection.';
	public static readonly SECTION_DESCRIPTION_DIMENSION_QUESTIONS =
		'A dimension can only include questions' +
		' from one Response Scale. Select a Response Scale for Questions you would like to add to this dimension.';
	public static readonly SECTION_DESCRIPTION_MANAGE_DIMENSION_QUESTIONS =
		'Deselecting questions will only disassociate the question from this dimension and not remove it from the survey. ' +
		'If the question is not part of any other dimension, it will appear under No dimension in Manage Dimensions screen.';
	public static readonly SECTION_DESCRIPTION_NO_CUSTOM_SURVEY_QUESTIONS = 'You have no custom survey questions created.';
	public static readonly SECTION_DESCRIPTION_NO_CUSTOM_DEMOGRAPHIC_QUESTIONS = 'You have no custom demographic questions created.';
	public static readonly SECTION_DESCRIPTION_DIMENSION_DETAIL_CREATE =
		'Select the survey questions you would' + ' like to associate with this dimension.';
	public static readonly SECTION_DESCRIPTION_DIMENSION_DETAIL_EDIT =
		'Select the survey questions you would' +
		' like to associate with this dimension. If you deselect a question, it will not be removed from the survey,' +
		' only disassociated from the dimension.';
	public static readonly SECTION_DESCRIPTION_DIMENSION_RESPONSE_GROUP =
		'This is the response option scale associated with this dimension. ' +
		'You can only choose questions for this dimension that have the same response option scale.';
	public static readonly SECTION_DESCRIPTION_REPORTING_USERS_BULK =
		"Give reporting access <strong>using a hierarchy's group access and profiles.</strong> " +
		'Group access and profiles are maintained in Org Manager.';
	public static readonly SECTION_DESCRIPTION_PROGRESS_METER = 'Choose what you want the survey progress meter to display.';
	public static readonly SECTION_DESCRIPTION_QUESTION_NUMBERING = 'Choose if you want numbering on questions to display on the survey.';
	public static readonly SECTION_DESCRIPTION_SURVEY_TYPE = 'Choose the driving concept or concepts of the survey.';
	public static readonly SECTION_DESCRIPTION_SURVEY_THEME_PRESETS = 'Explore a list of preset themes instead of customizing your own.';
	public static readonly SECTION_DESCRIPTION_SURVEY_THEME_BACKGROUND_COLOR = 'Change the background color for the survey.';
	public static readonly SECTION_DESCRIPTION_SURVEY_THEME_PRIMARY_COLOR =
		'Change the survey elements that appear throughout the survey (radio buttons, progress meter, checkboxes, etc.).';
	public static readonly SECTION_DESCRIPTION_SURVEY_THEME_PRIMARY_BUTTON =
		'Change the color and text of the primary action buttons which will progress the survey forward.';
	public static readonly SECTION_DESCRIPTION_SURVEY_THEME_SECONDARY_BUTTON = 'Change the "Save and Return Later" button and text color.';

	// INFO ICONS
	public static readonly INFOICON_TITLE_BENCHMARKS = 'Survey Benchmark';
	public static readonly INFOICON_TITLE_MIN_N = 'Anonymity Threshold';
	public static readonly INFOICON_DESCRIPTION_MIN_N =
		'Anonymity Threshold is the minimum number of responses required before data is shown for a report.';

	// BUTTONS
	public static readonly BUTTONS_SAVE = 'Save';
	public static readonly BUTTONS_COPY = 'Copy';
	public static readonly BUTTONS_CONTINUE = 'Continue';
	public static readonly BUTTONS_CREATE = 'Create';
	public static readonly BUTTONS_DONE = 'Done';
	public static readonly BUTTONS_CANCEL = 'Cancel';
	public static readonly BUTTONS_GO_BACK = 'Go Back';
	public static readonly BUTTONS_SAVE_AND_CLOSE = 'Save and Close';
	public static readonly BUTTONS_SAVE_AND_COMPLETE = 'Save and Complete';
	public static readonly BUTTONS_SAVE_AND_PUBLISH = 'Save and Publish';
	public static readonly BUTTONS_SAVE_AND_NEXT = 'Save and Go To Next Step';
	public static readonly BUTTONS_SAVE_AND_DISTRIBUTION = 'Save and Go To Distribution Options';
	public static readonly BUTTON_SAVE_CHANGES = 'Save Changes';
	public static readonly BUTTON_SYNC = 'Sync';
	public static readonly BUTTONS_SAVE_TRANSLATIONS = 'Save Translations';
	public static readonly BUTTONS_ADD_SURVEY_QUESTIONS = 'Add survey questions';
	public static readonly BUTTONS_ADD_DEMOGRAPHIC_QUESTIONS = 'Add demographic questions';
	public static readonly BUTTONS_FINISH_CLOSE = 'Finish and Close';
	public static readonly BUTTONS_PUBLISH_TO_MRESEARCH = 'Publish To mResearch';
	public static readonly BUTTONS_BUILD_NEW_SURVEY = 'Build New Survey';
	public static readonly BUTTONS_BUILD_FIRST_SURVEY = 'Build First Survey';
	public static readonly BUTTONS_CREATE_QUESTION = 'Create Question';
	public static readonly BUTTONS_CREATE_DEMOGRAPHIC_QUESTION = 'Create Demographic Question';
	public static readonly BUTTONS_CREATE_CUSTOM_QUESTION = 'Create Custom Question';
	public static readonly BUTTONS_UPDATE_QUESTION = 'Update Question';
	public static readonly BUTTONS_PREVIOUS_STEP = 'Previous Step';
	public static readonly BUTTONS_NEXT_STEP = 'Next Step';
	public static readonly BUTTONS_BACK_TO_QUESTIONS = 'Back To Questions';
	public static readonly BUTTONS_GO_TO_SURVEY_LIST = 'Go To Survey List';
	public static readonly BUTTONS_GO_TO_SURVEY_ADMIN = 'Go To Survey Admin';
	public static readonly BUTTONS_ADD_NEW_AUDIENCE = 'Add Audience';
	public static readonly BUTTONS_ADD_SURVEY_AUDIENCE = 'Add Survey Audience';
	public static readonly BUTTONS_SEND_TEST_EMAIL = 'Send Test Email';
	public static readonly BUTTONS_DOWNLOAD_TEMPLATE = 'Download Template';
	public static readonly BUTTONS_UPLOAD_FILE = 'Upload File';
	public static readonly BUTTONS_APPEND_DISTRIBUTION_LIST = 'Append Distribution List';
	public static readonly BUTTONS_CONFIRM_SCHEDULE = 'Confirm and Schedule';
	public static readonly BUTTONS_CLOSE = 'Close';
	public static readonly BUTTONS_UPDATE_AND_CLOSE = 'Update & Close';
	public static readonly BUTTONS_UPDATE = 'Update';
	public static readonly BUTTONS_ADD_SURVEY_LINK = 'link to survey';
	public static readonly BUTTONS_ADD_FIRST_NAME = 'first name';
	public static readonly BUTTONS_ADD_LAST_NAME = 'last name';
	public static readonly BUTTONS_ADD_EMAIL_ADDRESS = 'email address';
	public static readonly BUTTONS_ADD_ACCESS_CODE = 'access code';
	public static readonly BUTTONS_ADD_NEW_REMINDER = 'Add New Reminder';
	public static readonly BUTTONS_SAVE_EMAIL = 'Save Email';
	public static readonly BUTTONS_UPDATE_EMAIL = 'Update Email';
	public static readonly BUTTONS_DELETE_NOTE = 'Delete Note';
	public static readonly BUTTONS_ADD_CONDITION = 'Add Condition';
	public static readonly BUTTONS_ADD_USERS = 'Add Users';
	public static readonly BUTTONS_LOGOUT = 'Logout';
	public static readonly BUTTONS_CONFIRM = 'Confirm';
	public static readonly BUTTONS_CREATE_TEMPLATE = 'Create Template';
	public static readonly BUTTONS_MOVE_QUESTIONS = 'Move Questions';
	public static readonly BUTTONS_COPY_QUESTIONS = 'Copy Questions';
	public static readonly BUTTONS_ADD_PRIVACY_POLICY = 'Add Kincentric Privacy Policy';
	public static readonly BUTTONS_CLEAR_PRIVACY_POLICY = 'Clear Privacy Policy';
	public static readonly BUTTONS_MANAGE_CUSTOM = 'Manage Custom';
	public static readonly BUTTONS_ADD_ROW = 'Add Row';
	public static readonly BUTTONS_PREVIEW = 'Preview';

	// INPUT PLACEHOLDERS
	public static readonly INPUT_PLACEHOLDER_SEARCH_FOR_LANGUAGES = 'Search for languages...';
	public static readonly INPUT_PLACEHOLDER_NAME_YOUR_SURVEY_FILE = 'Name your survey file';
	public static readonly INPUT_PLACEHOLDER_ENTER_QUESTION_TEXT = 'Enter your question text here';
	public static readonly INPUT_PLACEHOLDER_DIMENSION_NAME = 'Dimension Name';
	public static readonly INPUT_PLACEHOLDER_ENTER_AUDIENCE_NAME = 'Name of your audience here';
	public static readonly INPUT_PLACEHOLDER_REMINDER_EMAIL_NAME = 'Name of your reminder email';
	public static readonly INPUT_PLACEHOLDER_REMINDER_EMAIL_SUBJECT = 'Subject line of your reminder email';
	public static readonly INPUT_PLACEHOLDER_REMINDER_EMAIL_CONTENT = 'Your reminder email content';
	public static readonly INPUT_PLACEHOLDER_INVITE_EMAIL_SUBJECT = 'Invite email subject line';
	public static readonly INPUT_PLACEHOLDER_INVITE_EMAIL_CONTENT = 'Your invite email content';
	public static readonly INPUT_PLACEHOLDER_TEST_EMAILS = 'Email address you want to receive the test email';
	public static readonly INPUT_PLACEHOLDER_REMINDER_EMAIL_SENDDATE = 'Send Date';
	public static readonly INPUT_PLACEHOLDER_SELECT_ATTRIBUTE = 'Select Attributes';
	public static readonly INPUT_PLACEHOLDER_SELECT_HIERARCHY = 'Select Hierarchies';

	// TOAST NOTIFICATIONS
	public static readonly TOAST_ERROR_GENERIC_BODY = 'You have error(s) on the page you need to ' + 'resolve before saving.';
	public static readonly TOAST_ERROR_GENERIC_TITLE = 'Error(s) on page';
	public static readonly TOAST_ERROR_GENERIC_LOAD_BODY = 'An error occurred while loading some of the data for this page.';
	public static readonly TOAST_ERROR_GENERIC_SAVE_BODY = 'An error occurred while saving some of the data for this page.';
	public static readonly TOAST_ERROR_PUBLISH_FAILURE_BODY =
		'A system error has occured while ' + 'trying to publish. Please try again later';
	public static readonly TOAST_ERROR_CANCEL_FAILURE_BODY = 'A system error has occurred while ' + 'trying to cancel.Please try again later';
	public static readonly TOAST_ERROR_PUBLISH_FAILURE_TITLE = 'Failure to Publish';
	public static readonly TOAST_ERROR_CANCEL_FAILURE_TITLE = 'Failure to Cancel the survey';
	public static readonly TOAST_SUCCESS_BODY = 'The information has been successfully saved.';
	public static readonly TOAST_SUCCESS_TITLE = 'Success!';
	public static readonly TOAST_DISPLAY_LOGIC_SAVED = 'Display Logic saved successfully';
	public static readonly TOAST_DISPLAY_LOGIC_ADDED = 'Display Logic created successfully';
	public static readonly TOAST_DISPLAY_LOGIC_SAVE_FAILED = 'Display Logic save failed';
	public static readonly TOAST_DIMENSION_DIMENSION_ADDED = 'Dimension created successfully';
	public static readonly TOAST_DIMENSION_DIMENSION_SAVED = 'Dimension saved successfully';
	public static readonly TOAST_DIMENSION_ADD_FAILED = 'Creating dimension failed';
	public static readonly TOAST_DIMENSION_EDIT_FAILED = 'Saving dimension failed';
	public static readonly TOAST_REMOVE_DIMENSION_SUCCESS = 'Dimension Removed successfully';
	public static readonly TOAST_REMOVE_DIMENSION_FAILED = 'Remove Dimension failed';
	public static readonly TOAST_DIMENSION_LOAD_FAILED = 'Loading dimensions failed';
	public static readonly TOAST_DIMENSION_QUESTION_MOVE_SUCCESS = 'Survey question(s) successfully moved to new dimension';
	public static readonly TOAST_DIMENSION_QUESTION_MOVE_FAILED = 'Moving survey question(s) to new dimension failed';
	public static readonly TOAST_DIMENSION_REMOVE_QUESTION_SUCCESS = 'Survey question(s) successfully removed from the dimension';
	public static readonly TOAST_DIMENSION_REMOVE_QUESTION_FAILED = 'Removing survey question(s) from the dimension failed';
	public static readonly TOAST_QUESTIONMODAL_ADDED = 'Question added to survey';
	public static readonly TOAST_QUESTIONMODAL_REMOVED = 'Question removed from survey';
	public static readonly TOAST_BENCHMARKMODAL_ADDED = 'Benchmark added';
	public static readonly TOAST_BENCHMARKMODAL_REMOVED = 'Benchmark removed';
	public static readonly TOAST_TEST_EMAIL_SENT = 'The test email has been sent';
	public static readonly TOAST_SURVEY_LINK_COPIED = 'Link copied to clipboard';
	public static readonly TOAST_DISTRIBUTION_CONTACT_DELETED = '{total} participant(s) have been deleted';
	public static readonly TOAST_SEND_TEST_EMAIL_VALIDATION = 'You must complete the entire email form before you can send a test email.';
	public static readonly TOAST_SEND_TEST_EMAIL_SUCCESS = 'The test email has been sent.';
	public static readonly TOAST_RESEND_EMAIL_SUCCESS = 'Emails has been sent to {total} participants.';
	public static readonly TOAST_REOPEN_SUCCESS = 'The survey has been reopened for {total} participants';
	public static readonly TOAST_REOPEN_RESEND_SUCCESS = `The survey has been reopened for {total} participants
	(and resent email)`;
	public static readonly TOAST_RESET_SUCCESS = 'The survey has been reset for {total} participants';
	public static readonly TOAST_RESET_RESEND_SUCCESS = `The survey has been reset for {total} participants
	(and resent email)`;
	public static readonly TOAST_PROCESSING_TEXT = 'Processing';
	public static readonly TOAST_FILE_UPLOAD_FAILED_TITLE = 'Error(s) in file';
	public static readonly TOAST_FILE_UPLOAD_FAILED_MESSAGE = 'You have error(s) in the file you need to resolve before uploading.';
	public static readonly TOAST_UPLOADING_PARTICIPANTS_TEXT = 'Uploading new participants.';
	public static readonly TOAST_VALIDATING_PARTICIPANTS_TEXT = 'Validating new participants.';
	public static readonly TOAST_UPLOADED_PARTICIPANTS_TEXT = 'The participants have been added.';
	public static readonly TOAST_UPLOADED_HIERARCHY_CUSTOM_ACCESS_CODES_TEXT = 'The access codes have been added';
	public static readonly TOAST_VALIDATED_PARTICIPANTS_TEXT = 'The participants have been validated successfully.';
	public static readonly TOAST_VALIDATING_TEXT = 'Validating';
	public static readonly TOAST_VALIDATED_TEXT = 'The list has been added.';
	public static readonly TOAST_AUDIENCE_COPIED = 'Audience copied';
	public static readonly TOAST_AUDIENCE_COPY_FAILED = 'Failed to copy Audience. Please try again';
	public static readonly TOAST_AUDIENCE_DELETED = 'Audience deleted';
	public static readonly TOAST_AUDIENCE_DELETED_FAILED = 'Failed to delete Audience. Please try again';
	public static readonly TOAST_REPORTING_USER_EMAIL_SENT = 'An email has been queued for this user.';
	public static readonly TOAST_REPORTING_USER_SAVE_FAILED = 'There is a problem with one or more reporting users.';
	public static readonly TOAST_REPORTING_USER_FAILED_TITLE = 'Save Failed';
	public static readonly TOAST_DELETE_FAILED_TITLE = 'Delete Failed';
	public static readonly TOAST_RESEND_FAILED_TITLE = 'Resend Failed';
	public static readonly TOAST_REOPEN_FAILED_TITLE = 'Reopen Failed';
	public static readonly TOAST_RESET_FAILED_TITLE = 'Reset Failed';
	public static readonly TOAST_SURVEY_PARTICIPANT_ACTION_FAILURE_BODY =
		'The system ran into issues while performing the action. Please try again';
	public static readonly TOAST_SURVEY_PRIVACY_POLICY_COPY_FAILED = 'Add Kincentric Privacy Policy failed';
	public static readonly TOAST_SURVEY_PRIVACY_POLICY_CLEAR_FAILED = 'Clear Privacy Policy failed';
	public static readonly TOAST_SURVEY_DEFINITION_FETCH_FAILED = 'Get survey definitions failed';
	public static readonly TOAST_SURVEY_DEFINITION_ADD_FAILED = 'Add survey definition failed';
	public static readonly TOAST_SURVEY_DEFINITION_DELETE_FAILED = 'Delete survey definition failed';
	public static readonly TOAST_BULK_COPY_SURVEYS_STARTED = 'Copy process started';
	public static readonly TOAST_BULK_COPY_SURVEYS_FINISHED = 'Copy process finished';
	public static readonly TOAST_INVALID_NUMBER = 'Number is invalid and will be reset.';
	public static readonly TOAST_ASSIGN_AUDIENCE_SUCCEEDED = 'View Participants in their assigned Audience Distribution List';
	public static readonly TOAST_MISSING_CUSTOM_ACCESS_CODES = 'Please upload custom access codes before continuing.';

	// INSTRUCTIONAL TITLE
	public static readonly INSTRUCTIONALTITLE_SURVEY_SCHEDULING = 'Your survey has been queued for scheduling!';
	public static readonly INSTRUCTIONALTITLE_SURVEY_SYNCING = 'Your survey is being synced!';

	// INSTRUCTIONAL TEXT
	public static readonly INSTRUCTIONALTEXT_ADD_DEMOGRAPHIC_QUESTIONS =
		'Use this section to add demographic questions to your survey. This is ' +
		'recommended for surveys administered through a generic link.';
	public static readonly INSTRUCTIONALTEXT_ADD_SURVEY_AUDIENCE =
		'This is the audience you want to distribute your survey to. ' +
		'After you add your survey audience, a table will represent them and their survey open / close dates.';
	public static readonly INSTRUCTIONALTEXT_ADD_SURVEY_CONTENT =
		'Use this section to add questions to  your survey.  You can choose up to 300 total questions, either survey or demographic questions.';
	public static readonly INSTRUCTIONALTEXT_AUDIENCE_OPEN_CLOSE_DATES =
		'These are the dates when your audience can take the survey. The invite email will be sent on the ' +
		'open date. We recommend you plan for at least 7 days for your employees to complete the survey. ' +
		'<strong>Note: These dates are not final. You can change them in the Survey Administration area.</strong>';
	public static readonly INSTRUCTIONALTEXT_CHOSEN_BENCHMARKS =
		'A survey benchmark is based on ' +
		'data collected from other Kincentric clients and will allow you to compare your results to top performing ' +
		'organizations and/or industry leaders.';
	public static readonly INSTRUCTIONALTEXT_CUSTOMQUESTION_CHOOSE_RESPONSEOPTION =
		'Your selection will be ' +
		'the response option for your custom survey question. Make sure your choice makes ' +
		'sense with the above question text.';
	public static readonly INSTRUCTIONALTEXT_CUSTOMQUESTION_CREATE_RESPONSEOPTION =
		'The created response option will be formatted as a series of radio buttons. ' +
		'A newly added option will be added as a radio button at the bottom of the series. ' +
		'If you have additional languages enabled, you need to add the translations for each option.';
	public static readonly INSTRUCTIONALTEXT_HIERARCHY_CREATE_RESPONSEOPTION =
		'Your selection will create a clickable view of the organization. ' +
		'Make sure that the proper hierarchy or employee file makes sense with the above question text.';
	public static readonly INSTRUCTIONALTEXT_CUSTOMQUESTION_CREATEDEMOGRAPHICQUESTION =
		'Click on the button below to create custom demographic questions. ' +
		'Remember, you will have to supply the translations for these questions into your chosen languages.';
	public static readonly INSTRUCTIONALTEXT_CUSTOMQUESTION_CREATESURVEYQUESTION =
		'Click on the button below to create custom survey questions. ' +
		'Remember, you will have to supply the translations for these questions into your chosen languages.';
	public static readonly INSTRUCTIONALTEXT_CUSTOMQUESTION_RESPONSEOPTION_CHANGE_TYPE =
		"If you choose Open-Ended or a scale response, you can't change to the other after creating the question.";
	public static readonly INSTRUCTIONALTEXT_CUSTOMQUESTION_RESPONSEOPTION_CHANGE_WARNING =
		'By changing the response option scale, your question will be removed from its current scored dimension and placed in No Dimension.';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_HIERARCHY_SELECTION =
		'This is the list of employees ' +
		'that will be invited to take the survey. They will receive the survey invite email and any reminder emails.';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_LIST_NOTE =
		'This is the list of emails that the survey invite email with survey link will be sent to. This link will also be' +
		' available in the survey administration section. Please download our distribution list template, fill it out' +
		', then upload it.';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_NODE_SELECTION =
		'To add, remove or move employees ' +
		'and/or nodes in this hierarchy, <a target="_blank" href="{url}">click on this link to open the hierarchy in ' +
		'Org Manager</a>.';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_SINGLE_LINK_SYSTEM =
		'<p>Our system automatically sends out an invitation email to each employee with the link ' +
		'to take your survey. This link will also be available in the survey administration section. ' +
		'Please write your survey invite email and any reminders, then download ' +
		'our distribution list template, fill it out and upload it.</p>' +
		'<p><strong>Note:</strong> <strong>If you don’t have any demographic questions added to your survey, ' +
		'please go back to the previous step and add some questions.</strong> This will allow you to filter ' +
		'and segment your results based on these demographics.</p>' +
		'<p>The link below will not work until the survey is scheduled.</p>';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_SINGLE_LINK_ACCESS_CODES =
		'<p>Our system will autogenerate unique access codes or you can create custom access codes.</p>' +
		'<p>Custom access codes will require manual input in the custom distribution list template that is uploaded.</p>';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_HIERARCHY_CUSTOM_ACCESS_CODES =
		'Please make your hierarchy selections below. Then download template and fill it out with custom access codes for the hierarchy selection, then upload it.';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_SINGLE_LINK_USER =
		'<p>Below is the single link to take your survey. ' +
		'Please send this link to everyone you want to take the survey. This link will also be available in the survey ' +
		'administration section.</p>' +
		'<p><strong>Note: If you don’t have any demographic questions added to your survey, ' +
		'please go back to the previous step and add some questions.</strong> ' +
		'This will allow you to filter and segment your results based on these demographics.</p>' +
		'<p>The link below will not work until the survey is scheduled.</p>';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_TEST_EMAIL_MULTI_EMAILS =
		'To send test emails to multiple users, use a comma between email addresses.';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_TEST_EMAIL_NOTE =
		'<b>Note:</b> The {link to survey} will not be replaced by the actual link in test emails.';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_UNIQUE_LINK =
		'<p>Our system automatically sends out an invitation email to each employee with a unique link to take your survey.</p>' +
		'<p>These unique links are matched one-to-one to your employees,' +
		' so you can do advanced demographic filtering and segmenting of your data based on ' +
		'your employee attributes in the template.</p>';

	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_SSO =
		'SSO refers to when a Client wants to use their own network to verify login. Single Sign-On (SSO) is a convenient authentication method that allows users to access our services with a single set of credentials.';
	public static readonly INSTRUCTIONALTEXT_SSO_IDENTIFIER =
		'Please choose one option from the following two choices. This selection is mandatory and is utilized to specify the column in the distribution file or hierarchy that serves as the identifier for Single Sign-On (SSO), commonly referred to as ExternalId.';
	public static readonly SSO_IDENTIFIER_SECTION_TITLE = 'SSO Identifier';

	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_UPLOAD_FAILED =
		'The distribution file {fileName} failed. Please try uploading again.';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_UPLOAD_INPROGRESS =
		'Your distribution list is currently being processed. ' +
		'Actions for Distributions List are not enabled until the system has finished processing.';
	public static readonly INSTRUCTIONALTEXT_DISTRIBUTION_UPLOAD_NOTSTARTED =
		'Your uploaded list {fileName} of {contactsCount} records will be processed ' +
		"to the distribution list when you click the 'Save' or 'Save and Complete' button. " +
		'Actions for Distributions List are not enabled until the system has finished processing.';
	public static readonly INSTRUCTIONALTEXT_GROUP_BASED_LINKS =
		'All your hierarchy nodes are automatically selected for this distribution type. ' +
		'The hierarchy below is the one you selected in the initial survey setup step. <br/>' +
		'<strong>The list of survey URLs per node will be available only after you schedule ' +
		'your survey in the Survey Control Panel.</strong>';
	public static readonly INSTRUCTIONALTEXT_GROUP_BASED_LINKS_DISTRIBUTION_LIST =
		'This is the list of hierarchy nodes that our system will generate a survey URL for. ' +
		'All the nodes will be selected by default and cannot be unselected.';
	public static readonly INSTRUCTIONALTEXT_INVITE_EMAIL_CONTENT =
		'If you have translations for your email' +
		' content, put them in this area as well. You can move the link to your survey around in the email content by' +
		' copy/paste. This link must be present in the email content.';
	public static readonly INSTRUCTIONALTEXT_INVITE_EMAIL_CONTENT_SSO =
		"You are using an SSO distribution type. When using SSO and the {link to survey} replacement key, the system will replace the key with the client's " +
		'mSuite subdomain and link them to their mSuite Survey Dashboard (not the routing page).';
	public static readonly INSTRUCTIONALTEXT_INVITE_EMAIL_FROM =
		'This is the name of the sender that will' +
		" appear in the employees' inbox. This name applies to both the invite and reminder emails.";
	public static readonly INSTRUCTIONALTEXT_INVITE_EMAIL_REPLY =
		'If an employee replies to the email, this' +
		' is the address that the reply will go to. This address applies to both the invite and reminder emails.';
	public static readonly INSTRUCTIONALTEXT_REMINDER_EMAIL_NOTE =
		'Note: You can also schedule and/or edit' + ' your reminder emails from the survey administration area after the survey has launched.';
	public static readonly INSTRUCTIONALTEXT_REMINDER_EMAIL_CONTENT =
		'If you have translations for your email' +
		' content, put them in this area as well. You can move the link to your survey around in the email content by' +
		' copy/paste. This link must be present in the email content.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_BENCHMARKS =
		'This is the list of benchmarks ' +
		'that will be available in the survey reporting and for you to compare your results against. If you wish ' +
		'to make any change please ';
	public static readonly INSTRUCTIONALTEXT_REPORTING_BENCHMARKS_BACK_LINK = 'go back to step 1';
	public static readonly INSTRUCTIONALTEXT_REPORTING__HIERARCHIES_SELECTION =
		'Select the specific managerial hierarchies you want available for Reporting.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_MIN_N =
		'The Anonymity Threshold is set for surveys at a client-' + 'level. You do have the option to override it.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_ATTRIBUTES =
		'Select the specific employee attributes you want available for Participation Monitor breakouts.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_HIERARCHIES =
		'Select the specific employee hierarchies you want available for Participation Monitor breakouts.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_HRIS_NO_LONGER_EXISTS =
		'The HRIS <strong>{hrisFileName}</strong> no longer exists. ';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_HRIS_NO_LONGER_EXISTS_TITLE = 'The HRIS used no longer exists.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_DATASOURCE =
		'This section is not available because you did not complete the <strong>Employee Data Source ' +
		'</strong> section in <strong>Initial Survey Setup step</strong>. ';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_DATASOURCE_2 =
		' and complete the Employee Data Source to enable this section.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_DATASOURCE_3 =
		'You can still do breakouts by demographics asked on the survey.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_DATASOURCE_LINK = 'Go back to Initial Survey Setup step';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_DATASOURCE_TITLE = 'This section is currently not available.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_DISTRIBUTION =
		"This section is not available because you haven't chosen a distribution type or your distribution type " +
		"uses a single link, or your distribution file didn't upload properly and you have no attributes to select. ";
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_DISTRIBUTION_2 =
		' and change your distribution type to <strong>Unique Link Our System Sends</strong> to enable this section.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_DISTRIBUTION_HIERARCHY =
		'This section is not available because you chose <strong>Hierarchy Structure</strong> as your employee data ' +
		'source. You can still do breakouts by nodes of the hierarchy.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_DISTRIBUTION_LINK = 'Go back to Distribute Your Survey step';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_HIERARCHIES = 'Your HRIS file has no other hierarchies. ';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_HIERARCHIES_2 = ' and select a new HRIS file.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PARTICIPATION_MONITOR_NO_HIERARCHIES_TITLE = 'Your HRIS file has no hierarchies.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_PROFILE =
		'Every reporting site user must be assigned a profile. ' +
		'Profiles are used to control when the invite email is sent out, filters and segments users have access to, and more. ' +
		'<strong>Note: You can edit these choices later.</strong>';
	public static readonly INSTRUCTIONALTEXT_REPORTING_TREND_1 = 'Trending allows you ';
	public static readonly INSTRUCTIONALTEXT_REPORTING_TREND_2 =
		'to compare your survey ' + "audience's results against past surveys they've taken. ";
	public static readonly INSTRUCTIONALTEXT_REPORTING_TREND_3 =
		'To do this, select the trend group below that ' + 'best matches your survey audience. If you’re still confused about trending, ';
	public static readonly INSTRUCTIONALTEXT_REPORTING_TREND_VIDEO = 'watch our short video';
	public static readonly INSTRUCTIONALTEXT_REPORTING_TREND_VIDEO_TARGET = '_blank';
	public static readonly INSTRUCTIONALTEXT_REPORTING_TREND_VIDEO_LINK = 'https://help.modernsurvey.com/Reporting/ReportingVideos.html';
	public static readonly INSTRUCTIONALTEXT_REPORTING_USERS =
		'Configure reporting site access below. <strong>Note: You can add, edit or revoke access later.</strong>';
	public static readonly INSTRUCTIONALTEXT_REPORTING_USERS_INDIVIDUAL =
		'Give reporting access <strong> ' +
		'one user at a time, up to 50 users</strong>. These users will have access to the entire reporting sites, ' +
		'including any hierarchies used. These will be added to the <strong>Individually added users</strong> profile ' +
		'below.';
	public static readonly INSTRUCTIONALTEXT_REPORTING_USERS_INDIVIDUAL_ADMIN =
		'Give reporting access one user at a time, up to 50 users. ' +
		'These users will have access to the overall survey dataset. ' +
		' Invite emails will be sent to the user upon survey close.';
	public static readonly INSTRUCTIONALTEXT_RESPONSE_STREAM =
		'Enable the option to immediately send surveys completed by users to reporting.';
	public static readonly INSTRUCTIONALTEXT_SURVEY_ERRORS =
		'This is the list of all the errors you have in ' +
		'the survey. <strong>You must correct all your errors before publishing to mResearch.</strong>';
	public static readonly INSTRUCTIONALTEXT_SURVEY_PUBLISH_FAILURE =
		'Your survey has failed to be' +
		' scheduled.<br/> Please try to schedule it again.<br/> If the issue persist, ' +
		'click <a target="_blank" href="https://msuitelink.com/support">here</a>' +
		' to contact our support team.';
	public static readonly INSTRUCTIONALTEXT_SURVEY_CLOSE_FAILURE = `Your survey has failed to close.<br/><br/>We are working on resolving this issue.`;
	public static readonly INSTRUCTIONALTEXT_SURVEY_SCHEDULING =
		'Congratulations! ' +
		'Your survey is now officially queued for scheduling and the status of the survey ' +
		'will be updated once it is scheduled. ' +
		'To verify the status of your survey, click the button below to go to the Survey List area.';
	public static readonly INSTRUCTIONALTEXT_SURVEY_SYNCING =
		'The syncing process may take a moment but we will have all edits synced as soon as possible.';
	public static readonly INSTRUCTIONALTEXT_SURVEY_TITLE =
		'This is the text ' +
		'that appears in your browser tab when the survey is opened or when ' +
		"the survey is bookmarked.  It's best practice to make the title describe what the survey " +
		'is for and to include some sort of time element (current year, 2nd quarter, etc) in it.';
	public static readonly INSTRUCTIONALTEXT_SURVEY_WARNINGS =
		'While you can still publish to mResearch ' + 'despite the warnings, we highly recommend you correct them before publishing.';
	public static readonly REPORTING_TRENDS_PREVIOUS_SURVEYS_DEFAULT_SELECTION = 'Trend Groups';
	public static readonly REPORTING_TRENDS_PREVIOUS_SURVEYS_INSTRUCTIONS =
		'These are the Pulse surveys ' + "<strong>you've previously conducted for {trendGroupName}</strong> that will be used for trending.";
	public static readonly REPORTING_TRENDS_PREVIOUS_SURVEYS_NOTE =
		`<strong>${ContentConstants.NOTE}:</strong> ` +
		"Users with access to this survey's reporting site will only see the trend surveys that " +
		'they also have reporting access to.';
	public static readonly TREND_SURVEYS_TOOL_TIP =
		'If a user has reporting access to a previous survey titled ' +
		'"Survey – Q2" but not "Survey – Q1", then this user will only see "Survey – Q2" as a trend to survey. In ' +
		'order for this user to see "Survey – Q1" as a trend to, then they must be added to the reporting access ' +
		'of "Survey – Q1".';
	public static readonly TREND_SURVEYS_TOOL_TIP_TITLE = 'Example:';
	public static readonly INSTRUCTIONALTEXT_MOVE_QUESTIONS_IN_SINGLE_RESPONSE_GROUP_TO_NEW_DIMENSION =
		'Choose a new dimension or index to move the {questionCount} chosen question(s) under.';
	public static readonly INSTRUCTIONALTEXT_MOVE_QUESTIONS_IN_MULTIPLE_RESPONSE_GROUPS_TO_NEW_DIMENSION =
		'Choose a new unscored dimension or index to move the {questionCount} chosen question(s) under. Because you have chosen <strong>questions with different response scales</strong>, only unscored dimensionses and indices will be available.';
	public static readonly INSTRUCTIONALTEXT_MOVE_QUESTIONS_NO_AVAILABLE_DIMENSIONS_MATCH_CRITERIA =
		'There is no dimension or index that meets the criteria to move the {questionCount} chosen question(s) under.';
	public static readonly INSTRUCTIONALTEXT_COPY_QUESTIONS_TO_NEW_DIMENSION =
		'Choose any unscored dimension or index to copy the {questionCount} chosen question(s) to.';
	public static readonly INSTRUCTIONALTEXT_COPY_QUESTIONS_NO_AVAILABLE_DIMENSIONS_MATCH_CRITERIA =
		'There is no dimension or index that meets the criteria to copy the {questionCount} chosen question(s) under.';
	public static readonly INSTRUCTIONALTEXT_CHOOSE_FOLLOWUP_QUESTION = 'Select one follow-up question.';
	public static readonly INSTRUCTIONALTEXT_CHOOSE_SURVEY_QUESTIONS =
		'Choose survey questions from the predefined Kincentric or client libraries.';
	public static readonly INSTRUCTIONALTEXT_PENDING_PARTICIPANTS_WARNING =
		'One or more participant(s) have been added to this survey. Please navigate to Survey Admin and create access codes for each user that has been added.';
	public static readonly PENDING_PARTICIPANTS_PULLOUT_TEXT =
		'<b>Participants(s) Added to Survey: </b>The following survey(s) had ' +
		'participant(s) added and require access codes to be assigned to each.';

	// SURVEY BASICS
	public static readonly INPUTLABEL_RENAME_SURVEY = 'Survey Name';
	public static readonly EMPLOYEEDATASOURCE_CHOOSE_YOUR_SOURCE = 'Choose Your Source';
	public static readonly PUBLISH_CHOOSE_YOUR_DESTINATION = 'Choose Your Destination';
	public static readonly REPORTING_APPLICATION_CHOOSE_YOUR_SOURCE = 'Choose Application';
	public static readonly REPORTING_APPLIACITON_CHOOSE_SURVEY_TYPES = 'Choose Survey Types';
	public static readonly EMPLOYEEDATASOURCE_CHOOSE_YOUR_FILE = 'Choose Your File';
	public static readonly EMPLOYEEDATASOURCE_NOHRISFILEOPTIONS_ERRORMESSAGE =
		'<b>WARNING:</b> There are no employee ' +
		'files uploaded in Org Manager or the employee files do not have hierarchies built from them. Please configure an HRIS file in ' +
		'Org Manager or select a different source.';
	public static readonly EXTERNAL_APPLICATION_TYPE_DISABLED = 'You need to enable this application in mSuite to enable it here.';
	public static readonly EMPLOYEEDATASOURCE_NOHIERARCHYFILE_ERRORMESSAGE =
		'<b>WARNING:</b> There are no hierarchy structures ' +
		'uploaded in Org Manager. Please configure a hierarchy in Org Manager or select a different source.';
	public static readonly EMPLOYEEDATASOURCE_CHANGEWARNING_MESSAGE =
		'<b>WARNING:</b> Changing the source type or file selection ' +
		'will cause the following pieces of data to be deleted: ' +
		'<ul><li>Branching that is using attributes and hierarchies</li>' +
		'<li>Participation Monitor breakout selections</li> ' +
		'<li>Distribution contacts</li></ul>';
	public static readonly EMPLOYEEDATASOURCE_NOTAVAIL_WARNING =
		'<b>WARNING:</b> The employee file you selected before has either ' +
		'been removed or the visibility settings have been changed to not ' +
		'be visible to others.';

	public static readonly LABEL_SURVEY_LOGO = 'Following are the guidelines for uploading the logo:';
	public static readonly LABEL_SURVEY_LOGO_MIME_TYPE = 'Image should be in the format bmp, jpg, png or gif.';
	public static readonly LABEL_SURVEY_LOGO_BACKGROUND = 'Image is recommended to have a transparent background.';
	public static readonly LABEL_SURVEY_LOGO_DIMENSION = 'Image is recommended to fit image within 350 pixels width by 50 pixels height.';
	public static readonly LABEL_SURVEY_LOGO_FILE_SIZE = 'Maximum size of the image file should be 200KB.';
	public static readonly LABEL_SURVEY_LOGO_NAME = 'This is the logo name that can be used by a screen reader when applicable.';
	public static readonly LABEL_SURVEY_PROGRESS_METER_TYPE = 'Progress Meter Type';

	// INPUT LABELS
	public static readonly INPUTLABEL_SURVEY_TITLE =
		'The title that survey takers will see on all the survey pages. ' +
		'If you have additional languages, be sure it is translated into these languages.';

	public static readonly INPUTLABEL_SURVEY_INTRO =
		'This is the introductory text to your survey. ' +
		"If you're using a survey intro, be sure it's translated into all of your enabled languages.";
	public static readonly INPUTLABEL_SURVEY_INSTRUCTIONS =
		'This is the instruction text for your survey. ' +
		"If you're using survey instructions, be sure it's translated into all of your enabled languages.";
	public static readonly INPUTLABEL_PRIVACY_POLICY = 'Include a Privacy Policy that employees agree to during the survey.';
	public static readonly INPUTLABEL_PRIVACY_POLICY_CHECKBOX_HELPTEXT =
		'If you choose not to enter checkbox text, the system will treat this privacy policy as not requiring user approval.';
	public static readonly INPUTLABEL_SURVEY_TEXTTOSPEECH_INSTRUCTIONS =
		'These are instructions in your survey for the text-as-audio feature. By default we provide our standard instructions, ' +
		'including translations. You may choose to replace these with custom instructions.';
	public static readonly INVITE_EMAIL_FROM = 'From';
	public static readonly INVITE_EMAIL_REPLYTO = 'Reply To';
	public static readonly INVITE_EMAIL_SUBJECT_LINE = 'Subject Line';
	public static readonly INVITE_EMAIL_CONTENT = 'Content';
	public static readonly INVITE_EMAIL_CONTENT_DESCRIPTION =
		'If you have translations for your email content' +
		', put them in this area as well. You can move the link to your usrvey around in the email content by copy / paste.' +
		'This link must be present in the email content.';
	public static readonly INVITE_EMAIL_TEMPLATES = 'Templates';
	public static readonly INVITE_EMAIL_TEMPLATES_INSTRUCTIONS = 'Select an email template to fill in the fields below.';
	public static readonly INPUTLABEL_PROGRESS_METER_PAGE_NUMBER = 'Page Number';
	public static readonly INPUTLABEL_PROGRESS_METER_PAGE_PERCENTAGE = 'Page Percentage';
	public static readonly INPUTLABEL_QUESTION_NUMBERING_YES = 'Yes';
	public static readonly INPUTLABEL_QUESTION_NUMBERING_NO = 'No';

	// QUESTIONS TABLE
	public static readonly TABLE_HEADER_ACTIONS = 'Actions';
	public static readonly TABLE_HEADER_DIMENSIONTEXT = 'Dimension & ';
	public static readonly TABLE_HEADER_FOLLOW_UP_QUESTION = 'Follow-Up Question';
	public static readonly TABLE_HEADER_HIDE_QUESTION = 'Hide Question';
	public static readonly TABLE_HEADER_QUESTION_LOGIC = 'Question Logic';
	public static readonly TABLE_HEADER_QUESTIONTEXT = 'Question';
	public static readonly TABLE_HEADER_QUESTIONTYPE = 'Question Type';
	public static readonly TABLE_HEADER_RESPONSEOPTION = 'Response Option';
	public static readonly TABLE_HEADER_RESPONSE_REQUIRED = 'Response Required';
	public static readonly TABLE_HEADER_LOGIC = 'Logic';
	public static readonly TABLE_HEADER_CONDITION = 'Condition';

	public static readonly SURVEYQUESTIONS_THRESHOLD = 80;
	public static readonly SURVEYQUESTIONS_THRESHOLD_EXCEEDED =
		'You have exceeded the ' +
		'maximum number of 80 survey questions allowed. You will not be allowed to ' +
		'schedule your survey until you remove some of the questions.';

	public static readonly SELECT_SCORED_DIMENSION_MODAL_TITLE = 'Select A Dimension';
	public static readonly SELECT_SCORED_DIMENSION_MODAL_INSTRUCTIONS_PART_ONE = 'You selected a question ';
	public static readonly SELECT_SCORED_DIMENSION_MODAL_INSTRUCTIONS_PART_TWO = 'with multiple scored dimensions';
	public static readonly SELECT_SCORED_DIMENSION_MODAL_INSTRUCTIONS_PART_THREE =
		' and a question can only be added to 1 scored dimension. If nothing is selected, it will be added to "No Dimension."';
	public static readonly SELECT_SCORED_DIMENSION_MODAL_DROPDOWN_TEXT = 'Select a scored dimension';
	public static readonly FOLLOW_UP_QUESTION_DROPDOWN_STANDARD_QUESTION = 'Standard Question';
	public static readonly FOLLOW_UP_QUESTION_DROPDOWN_CUSTOM_QUESTION = 'Custom Question';
	public static readonly FOLLOW_UP_QUESTION_RESPONSE_OPTION_GROUP_TOOLTIP =
		'Response Options can be selected during Step 3, Design your survey.';

	// QUESTION DISPLAY LOGIC
	public static readonly DISPLAY_LOGIC_MODAL_CREATE_HEADER_TEXT = 'Set Question Logic';
	public static readonly DISPLAY_LOGIC_QUESTION_LIST_VALIDATION_BUTTON = 'Run Validation';
	public static readonly DISPLAY_LOGIC_MODAL_EDIT_HEADER_TEXT = 'Edit Question Logic';
	public static readonly DISPLAY_LOGIC_MODAL_SHOW_HIDE_DROPDOWN_TEXT = 'Show/Hide';
	public static readonly DISPLAY_LOGIC_ACTION_TYPE_DROPDOWN_TEXT = 'Select a rule action type';
	public static readonly DISPLAY_LOGIC_ACTION_TYPE_HIDE_QUESTION_LABEL = 'Hide';
	public static readonly DISPLAY_LOGIC_ACTION_TYPE_SHOW_QUESTION_LABEL = 'Show';
	public static readonly DISPLAY_LOGIC_ACTION_TYPE_BRANCH_TO_QUESTION_LABEL = 'Skip';
	public static readonly DISPLAY_LOGIC_ACTION_DESTINATION_QUESTION_DROPDOWN_TEXT = 'Select the destination question';
	public static readonly DISPLAY_LOGIC_PREVIOUS_QUESTION_DROPDOWN_TEXT = 'Select Question';
	public static readonly DISPLAY_LOGIC_HIERARCHY_DROPDOWN_TEXT = 'Select Hierarchy';
	public static readonly DISPLAY_LOGIC_PREVIOUS_QUESTION_RESPONSES_DROPDOWN_TEXT = 'Select Response(s)';
	public static readonly DISPLAY_LOGIC_ATTRIBUTE_DROPDOWN_TEXT = 'Select Attribute';
	public static readonly DISPLAY_LOGIC_ATTRIBUTE_DROPDOWN_VALUES_TEXT = 'Select Value(s)';
	public static readonly DISPLAY_LOGIC_MODAL_QUESTION_PREFIX = 'QUESTION: ';
	public static readonly DISPLAY_LOGIC_MODAL_NO_CONDITIONS_TEXT = 'You do not have any conditions added for branching.';
	public static readonly DISPLAY_LOGIC_MODAL_CONDITION_DROPDOWN_PREVIOUS_QUESTION = 'Based on response to a previous question';
	public static readonly DISPLAY_LOGIC_MODAL_CONDITION_DROPDOWN_THIS_OR_PREVIOUS_QUESTION =
		'Based on response to this question or a previous question';
	public static readonly DISPLAY_LOGIC_MODAL_CONDITION_DROPDOWN_ATTRIBUTE = 'Based on attributes of employee file / distribution list';
	public static readonly DISPLAY_LOGIC_MODAL_CONDITION_DROPDOWN_HIERARCHY = 'Based on nodes of a hierarchy file';
	public static readonly DISPLAY_LOGIC_CONDITION_ERROR_NO_SOURCE_PART1 =
		" This option is not available because you haven't completed " + 'the Employee Data Source section. ';
	public static readonly DISPLAY_LOGIC_CONDITION_ERROR_NO_SOURCE_PART2 = 'Go to initial survey setup';
	public static readonly DISPLAY_LOGIC_CONDITION_ERROR_NO_SOURCE_PART3 = ' step and complete the section.';
	public static readonly DISPLAY_LOGIC_CONDITION_ERROR_SOURCE_NO_DIST_PART1 =
		" This option is not available because you haven't completed " +
		'the distribute your survey step or your distribution type uses a single link. ';
	public static readonly DISPLAY_LOGIC_CONDITION_ERROR_SOURCE_NO_DIST_PART2 = 'Go to Distribute your survey';
	public static readonly DISPLAY_LOGIC_CONDITION_ERROR_SOURCE_NO_DIST_PART3 =
		' step and select the distribution ' + 'type to Unique Link For Each Employee to enable this option.';
	public static readonly DISPLAY_LOGIC_CONDITION_ERROR_OTHER_SOURCE =
		' This option is not available because the selected' + ' Employee Data Source doesnt match this option';
	public static readonly DISPLAY_LOGIC_CONDITION_ERROR_NO_HRIS_ID = 'AudienceSourceType is set to HRIS and there is no HrisId.';
	public static readonly NO_RESPONSE = 'No Response';
	public static readonly NEW_DISPLAY_LOGIC_RULE = 'Create a new display logic rule';
	public static readonly DISPLAY_LOGIC_IF_PREVIOUS_QUESTION = 'If answer to';
	public static readonly DISPLAY_LOGIC_IF_ATTRIBUTE = 'If value of attribute';
	public static readonly DISPLAY_LOGIC_IF_HIERARCHY = 'If Survey taker is part of the hierarchy';
	public static readonly DISPLAY_LOGIC_IS = 'is';
	public static readonly DISPLAY_LOGIC_TO = 'To';
	public static readonly DISPLAY_LOGIC_AND_NODES = 'and node(s)';
	public static readonly TABLE_HEADER_FOLLOWUP_QUESTION = 'follow up question';
	public static readonly FOLLOWUP_QUESTION_NO_DIMENSION_WARNING = ' Warning - Select a response option';
	public static readonly FOLLOWUP_QUESTION_DIMENSION_RENAME_WARNING =
		' Warning - Dimension is binded with followup questions options and not able to update.';
	public static readonly FOLLOWUP_QUESTION_NO_SURVEY_DIMENSION = ' No dimension added to survey. Go back to Manage dimensions step';
	public static readonly FOLLOWUP_QUESTION_HEADER_MAX_RESPONSESES = 'MAX RESPONSES';
	public static readonly FOLLOWUP_QUESTION_HEADER = 'FOLLOW UP QUESTION';
	public static readonly FOLLOWUP_QUESTION_HEADER_RESPONSESE_OPTIONS = 'RESPONSE OPTIONS';

	// DIMENSION TABLE
	public static readonly DIMENSION_FILTER_ALL_DIMENSIONS_KEY = 'alldimensions';
	public static readonly DIMENSION_FILTER_ALL_DIMENSIONS_VALUE = 'All Dimensions';
	public static readonly DIMENSION_FILTER_LIBRARY_DIMENSIONS_VALUE = 'Library Dimensions';
	public static readonly DIMENSION_FILTER_CUSTOM_DIMENSIONS_VALUE = 'Custom Dimensions';
	public static readonly DIMENSION_NEW_CUSTOM_DIMENSION = 'Create Custom Dimension';
	public static readonly CUSTOM_DIMENSION_SELECT_DISPLAY_TEXT = 'Select';
	public static readonly DIMENSION_EDIT_CUSTOM_DIMENSION = 'Save';
	public static readonly DIMENSION_CANCEL_CUSTOM_DIMENSION = 'Cancel';
	public static readonly DIMENSION_TABLE_DROPDOWN_COPY_CUSTOM = 'Copy As Custom';
	public static readonly DIMENSION_TABLE_DROPDOWN_COPY = 'Copy';
	public static readonly DIMENSION_TABLE_DROPDOWN_EDIT = 'Edit';
	public static readonly DIMENSION_TABLE_DROPDOWN_REMOVE = 'Remove';

	// DIMENSION CATEGORIES
	public static readonly DIMENSION_CATEGORIES_NO_DIMENSIONS = 'No Dimensions';
	public static readonly DIMENSION_CATEGORIES_DEMOGRAPHIC = 'Demographic';

	// SURVEY DIMENSION MODAL
	public static readonly TOOLTIP_DIMENSION_TYPE_TEXT =
		'An Index is a grouping of items, mostly unique to a client, ' +
		'that measures non-engagement concepts – i.e., Engaging Leader, Agility';
	public static readonly TOOLTIP_DIMENSION_ISSCORED_TEXT =
		'Scored dimension – calculates the average favorability of the items within the dimension/category';

	// TRANSLATIONS
	public static readonly TRANSLATIONS_DIMENSION = 'dimension';
	public static readonly TRANSLATIONS_QUESTION = 'question';
	public static readonly TRANSLATIONS_SECTION_HEADER = 'section header';
	public static readonly TRANSLATIONS_DESCRIPTION_TEXT = 'text';
	public static readonly TRANSLATIONS_RESPONSEOPTION = 'response option';
	public static readonly TRANSLATIONS_DEFAULT_TRANSLATION_REQUIRED = 'You must enter a {property} before you can translate it.';

	// BENCHMARKS
	public static readonly BENCHMARKS_MODAL_TITLE = 'All Benchmarks';
	public static readonly BENCHMARKS_CLICKBOX_TEXT = 'Click to add benchmarks';

	// SEARCH
	public static readonly SEARCH_NO_RESULTS_TITLE = 'No Search Results';
	public static readonly SEARCH_NO_RESULTS_MESSAGE = 'There are no results for this search.';

	// Custom Question
	public static readonly CUSTOM_QUESTION_RECOMMENDED_TEXT = 'Recommended character limit:';
	public static readonly CUSTOM_QUESTION_DEFAULT_DIMENSION = `
					<p>No Dimension (Default)</p>
					<p>You can change the dimension this question is under in the next sub-step <strong>Manage Dimensions.</strong></p>`;

	public static readonly MISSING_BENCHMARK_TOOLTIP_TITLE_TEXT = 'Missing Chosen Benchmarks';
	public static readonly MISSING_BENCHMARK_TOOLTIP_REMINDER_TEXT = 'To change your enabled benchmarks, go back to the previous step.';

	public static readonly MISSING_LANGUAGES_TOOLTIP_TITLE_TEXT = 'Missing Chosen languages';
	public static readonly MISSING_LANGUAGES_TOOLTIP_REMINDER_TEXT = 'To change your enabled languages, go back to the previous step.';
	public static readonly SURVEYQUESTIONLIST_MISSING_TRANSLATIONS = 'You are missing translation(s)';

	public static readonly MAPPED_ATTRIBUTE_SELECTOR_TEXT = 'Select An Attribute';
	public static readonly CUSTOM_DEMOGRAPHIC_QUESTION_MAPPED_ATTRIBUTE_HEADER = 'Mapped Attribute';
	public static readonly CUSTOM_DEMOGRAPHIC_QUESTION_MAPPED_ATTRIBUTE_MESSAGE =
		'Every demographic question ' +
		'either from the library or custom must have a filter/segment attribute mapped to it. Please select an ' +
		'attribute for your question below. You can only select attributes that have not been selected yet. ' +
		'<strong>Note: mapped attributes that are currently in use or are in another custom demographic question ' +
		'will be disabled in the dropdown and not selectable.</strong>';
	public static readonly CUSTOM_DEMOGRAPHIC_QUESTION_MAPPED_ATTRIBUTE_REQUIRED = 'Please select a value.';

	public static readonly MAPPED_ATTRIBUTE_TOOLTIP_TITLE = 'Mapped Attribute';
	public static readonly MAPPED_ATTRIBUTE_TOOLTIP_BODY =
		'You will be able to filter and segment your ' +
		'data based on responses to this question. This is the name of the attribute you will use for ' +
		'filtering and segmenting your data.';
	public static readonly MAPPED_ATTRIBUTE_IN_USE_BY_CUSTOM_TOOLTIP_BODY =
		'Attribute already in use. ' +
		"This attribute is already in use by one of your selected custom demographic questions. If you'd " +
		"like to select this question, please deselect the custom demographic question that's using " +
		'this attribute, then select this question.';
	public static readonly MAPPED_ATTRIBUTE_IN_USE_BY_LIBRARY_TOOLTIP_BODY =
		'Attribute already in use. ' +
		"This attribute is already in use by one of your selected library demographic questions.  If you'd " +
		"like to select this question, please deselect the library demographic question that's using this " +
		'attribute, then select this question.';
	public static readonly RESPONSE_OPTION_GROUP_OPEN_ENDED = 'Open Ended';
	public static readonly RESPONSE_OPTION_GROUP_TEXT_BOX = 'Text Box';
	public static readonly RESPONSE_OPTION_GROUP_TEN_POINT = '10-Point Scale';
	public static readonly RESPONSE_OPTION_GROUP_SEVEN_POINT_AGREE = '7-Point Agree';
	public static readonly RESPONSE_OPTION_GROUP_SEVEN_POINT_SATISFACTION = '7-Point Satisfaction';
	public static readonly RESPONSE_OPTION_GROUP_THREE_POINT_MANAGER_SUPPORT = '3-Point Manager Support';

	// Custom Response Options
	public static readonly CUSTOM_RESPONSEOPTION_LABEL_PLACEHOLDER = 'Name of label';
	public static readonly CUSTOM_RESPONSEOPTION_HEADER_LABEL = 'Response Label';
	public static readonly CUSTOM_RESPONSEOPTION_HEADER_TRANSLATIONS = 'Translations';
	public static readonly CUSTOM_RESPONSEOPTION_HEADER_VALUE = 'Value';
	public static readonly CUSTOM_RESPONSEOPTION_HEADER_VALUE_TOOLTIP_TITLE = 'Response Option - Value';
	public static readonly CUSTOM_RESPONSEOPTION_HEADER_VALUE_TOOLTIP_TEXT =
		'This is the value that will be entered in the database for your response option. ' +
		'While you can change the values, we recommend you keep the default values we provide.';
	public static readonly CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP = 'Follow-Up';
	public static readonly CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP_TOOLTIP_TITLE = 'Response Option - Follow-Up';
	public static readonly CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP_TOOLTIP_TEXT =
		'A follow up is a text box following the response option to gather additional information from that participant. ' +
		'It is recommended that this be the last response option for that question and can only be included on one response option.';
	public static readonly CUSTOM_RESPONSEOPTION_ADD_TEXT = 'Add response';
	public static readonly CUSTOM_RESPONSEOPTION_ERROR_LABEL_EMPTY = 'You must enter a label name.';
	public static readonly CUSTOM_RESPONSEOPTION_ERROR_LABEL_LENGTH_EXCEEDED =
		'You have exceeded the max character limit of 150 for this input or translation. Please delete the necessary characters.';
	public static readonly CUSTOM_RESPONSEOPTION_ERROR_VALUE_EMPTY = 'You must enter a value.';
	public static readonly CUSTOM_RESPONSEOPTION_ERROR_VALUE_DUPLICATE = 'You cannot have duplicate values.';

	public static readonly RESPONSE_OPTION_GROUP_OPENENDED = 'Open-Ended';
	public static readonly RESPONSE_OPTION_GROUP_OPENENDED_DESCRIPTION =
		'Supports comments up to multiple lines of text, encouraging respondents to provide a longer response.';
	public static readonly RESPONSE_OPTION_GROUP_TEXTBOX = 'Text Box';
	public static readonly RESPONSE_OPTION_GROUP_TEXTBOX_DESCRIPTION =
		'Supports comments up to a single line of text, encouraging respondents to provide a short response.';
	public static readonly CUSTOM_RESPONSEOPTION_MISSING = 'You must choose a response option.';
	public static readonly CUSTOM_QUESTION_TEXT_MISSING = 'You must enter question text.';
	public static readonly CUSTOM_RESPONSE_OPTION_NAME = 'Response Option Name';

	public static readonly INVITE_EMAIL_PLACEHOLDER_FROM = 'Name of email sender';
	public static readonly INVITE_EMAIL_PLACEHOLDER_REPLYTO = 'Email address of email sender';
	public static readonly CUSTOM_RESPONSE_OPTION_LABEL_HIERARCHY = 'Hierarchy';
	public static readonly CUSTOM_RESPONSE_OPTION_PLACEHOLDER_HIERARCHY = 'Choose your hierarchy';
	public static readonly CUSTOM_RESPONSE_OPTION_UPLOAD_HIERARCHY = 'Upload Hierarchy File';

	// Warning Modals
	public static readonly WARNING_MODAL_TITLE = 'Warning';
	public static readonly WARNING_MODAL_UNSAVED_HEADLINE = 'You have unsaved data on this page.';
	public static readonly WARNING_MODAL_UNSAVED_BODY =
		'By navigating away from this page before saving, ' +
		"you'll lose all the unsaved data on the page. Are you sure you wish to continue?";
	public static readonly WARNING_MODAL_REPUBLISH_HEADLINE = 'This action cannot be undone.';
	public static readonly WARNING_MODAL_REPUBLISH_BODY =
		'By re-publishing this ' +
		'survey in mResearch, your old version will be archived and a new version will be created. Are you sure you wish' +
		' to re-publish {surveyName}?';
	public static readonly WARNING_MODAL_DELETE_HEADLINE = 'This action cannot be undone.';
	public static readonly WARNING_MODAL_DELETE_BODY =
		'The {name} will be permanently deleted from the system, ' +
		'including any associated data. Are you sure you wish' +
		' to delete {name}?';
	public static readonly COPY_AUDIENCE_MODAL_TITLE = 'Copy Audience';
	public static readonly COPY_AUDIENCE_MODAL_NO_DISTRIBUTION_HEADLINE = 'Note';
	public static readonly COPY_AUDIENCE_MODAL_DISTRIBUTION_HEADLINE = 'Instructions';
	public static readonly COPY_AUDIENCE_MODAL_CHECKBOX_LABEL = 'Test Audience';
	public static readonly COPY_AUDIENCE_MODAL_DISTRIBUTION_BODY = 'Update the distribution list to complete the copy audience process.';
	public static readonly COPY_AUDIENCE_MODAL_NO_DISTRIBUTION_BODY = 'Would you like to make this a test audience?';
	// Delete survey message does not include replacement text and rearranges some phrasing.
	public static readonly WARNING_MODAL_DELETESURVEY_BODY =
		'The survey file including any associated data will be ' +
		'permanently deleted from the system.  Are you sure you ' +
		'wish to delete the survey?';
	public static readonly WARNING_MODAL_RESEND_HEADLINE = 'Resending email to participants.';
	public static readonly WARNING_MODAL_RESEND_BODY = 'You are about to send email to {total} participants. ' + 'Do you wish to continue?';
	public static readonly WARNING_MODAL_REOPEN_HEADLINE = 'Reopening survey for participants.';
	public static readonly WARNING_MODAL_REOPEN_BODY = `This action will reopen the survey for {total} participants. This
	action cannot be undone and the status will be set to "In Progress". The participants will be able to review / change
	the responses and will need to resubmit again. Are you sure you wish to continue?`;
	public static readonly WARNING_MODAL_RESET_HEADLINE = 'Resetting survey for participants.';
	public static readonly WARNING_MODAL_RESET_BODY = `This action will reset the survey and responses for {total}
	participants. This
	action cannot be undone and the status will be set to "Not Started". The participants will need to complete the survey
	and submit again. Are you sure you wish to continue?`;
	public static readonly WARNING_MODAL_OPEN_CLOSE_DATES_HEADLINE = 'You have reminder email(s) that will not be sent out.';
	public static readonly WARNING_MODAL_OPEN_CLOSE_DATES_BODY = `You have reminder email(s) scheduled outside the
		survey open and close dates you've just selected. These reminders(s) will not be sent out by our system.
		 Either correct the reminder email(s) time / date or select new survey open and close dates.`;
	public static readonly WARNING_MODAL_SURVEY_TEMPLATE_EDIT_HEADLINE = 'Setting survey template to draft.';
	public static readonly WARNING_MODAL_SURVEY_TEMPLATE_EDIT_BODY = `This action will set the survey template to draft status,
		 and allow you to edit it. The survey template will not be available for copy until it is made public again.`;
	public static readonly WARNING_MODAL_DELETE_DIMENSION_HEADLINE = 'This action cannot be undone.';
	public static readonly WARNING_MODAL_DELETE_DIMENSION_BODY = `This action will permanently delete the index or dimension. For any questions where this is the only dimension/index they're assigned to, these questions will be moved to <strong>No Dimension</strong>. Are you sure you wish to continue?`;
	public static readonly WARNING_MODAL_DELETE_DIMENSION_NOT_ALLOWED =
		'The dimension is already selected as a follow-up question response option and it cannot be deleted.';
	public static readonly WARNING_MODAL_REMOVE_DIMENSION_QUESTION_HEADLINE = 'Questions will be moved to No Dimension.';
	public static readonly WARNING_MODAL_REMOVE_DIMENSION_QUESTION_BODY = `You are removing {questionCount} question(s) from the dimension or index. As a result, any question which does not belong to another dimension or index will be automatically moved to <strong>No Dimension</strong>. Are you sure you wish to continue?`;
	public static readonly WARNING_MODAL_ACTION_CANNOT_BE_UNDONE_HEADLINE = 'This action cannot be undone.';
	public static readonly WARNING_MODAL_DISCARD_UNSYNCED_EDITS_BODY = 'All unsynced edits will be lost if you cancel.';
	public static readonly WARNING_MODAL_SYNC_LIVE_SURVEY_EDITS_BODY =
		'All synced edits will update live survey content. Are you sure you want to sync edits?';
	public static readonly WARNING_REMINDER_EMAILS_SCHEDULEDFOR = `Warning: This email send date is outside the survey open / close dates
		and will not be sent out unless corrected.`;
	public static readonly WARNING_DELETE_PARTICIPANTS_BODY = `You are about to permanently delete {total} participant(s),
		including associated survey data for reporting from the system. Do you wish to continue?`;
	public static readonly WARNING_DELETE_PARTICIPANTS_SINGLELINK_BODY = `You are about to permanently delete {total}
		participant(s), including associated survey data for reporting from the system. Do you wish to continue?
		<p/><p>The deletion of selected participants will only affect the emails that
		have been set up for this distribution.</p>`;
	public static readonly WARNING_DISTRIBUTION_DATA_TRANSFER_HEADLINE = 'Transfer your previous distribution data.';
	public static readonly WARNING_DISTRIBUTION_DATA_TRANSFER_BODY = `Would you like to transfer current data to the new distribution choice?`;
	public static readonly WARNING_DISTRIBUTION_ACCESSCODE_TRANSFER_BODY = `You currently have access code in your email which is not supported by the unique links distribution option. If you continue, it will be removed from the email.`;
	public static readonly WARNING_DISTRIBUTION_OPTION_WARNING_HEADLINE = 'Your saved distribution option will be replaced. ';
	public static readonly WARNING_DISTRIBUTION_OPTION_WARNING_BODY = `Changing to this distribution option will cause you to lose all associated data from the current option.
		Do you wish to continue?`;
	public static readonly WARNING_CANCEL_SURVEY_HEADLINE = 'Cancel Survey';
	public static readonly WARNING_CANCEL_EVENT_HEADLINE = 'Cancel Event';
	public static readonly WARNING_CANCEL_SURVEY_BODY =
		'This action cannot be undone. By cancelling your survey, it will be archived and cannot be restarted. ' +
		'You can still make a copy of this survey though in the Survey Builder. ' +
		'Are you sure you wish to cancel ';
	public static readonly WARNING_CANCEL_EVENT_BODY =
		'This action cannot be undone. By cancelling your event, it will be archived and cannot be restarted. ' +
		'Are you sure you wish to cancel {audienceName}?';
	public static readonly WARNING_CUSTOM_DIMENSION_RESPONSE_OPTION_CHANGE = `By changing this dimension's response option, all the questions currently under it will be moved to No Dimensions.`;
	public static readonly WARNING_CUSTOM_DIMENSION_IS_SCORED_CHANGE = `By changing this dimension from unscored to scored, all the questions that don't have the same response scale as selected below it will be moved to No Dimensions.`;
	public static readonly WARNING_TRANSLATIONS_AFFECTED_HEADING = 'Translations Affected';
	public static readonly WARNING_TRANSLATIONS_AFFECTED_BODY =
		'Editing the {property} of the {model} could cause translations to be inaccurate. Please check your translations and update accordingly.';
	public static readonly WARNING_PRIVACY_POLICY_OFF_HEADLINE = 'Turn Privacy Policy Off?';
	public static readonly WARNING_PRIVACY_POLICY_OFF_BODY =
		'<p>Employees will not be able to review privacy policy content when turned off.</p> ' +
		`<p>Note: All content that was created in the privacy policy section will be saved when turned off.</p>`;
	public static readonly WARNING_ADD_PRIVACY_POLICY_HEADLINE = `Add Kincentric's Privacy Policy?`;
	public static readonly WARNING_ADD_PRIVACY_POLICY_BODY = `<p>All custom privacy policy content as well as any translated versions will be replaced with the Kincentric Privacy Policy.</p>`;
	public static readonly WARNING_CLEAR_PRIVACY_POLICY_HEADLINE = 'Clear Privacy Policy Content?';
	public static readonly WARNING_CLEAR_PRIVACY_POLICY_BODY =
		`<p>Content that has been added to the Privacy Policy section will be removed.</p> ` +
		`<p>The option to add Kincentric's Privacy Policy will be available again.</p>`;
	public static readonly WARNING_INVITE_EMAIL_TEMPLATE_CHANGE = `Are you sure you would like to overwrite your invite email data with the data from template: {template name}?`;

	// ERROR MESSAGES
	public static readonly WARNING_MISSING_TRANSLATIONS = 'You are missing translation(s).';
	public static readonly WARNING_MISSING_DEFAULT_TRANSLATION = 'Default translation is missing.';
	public static readonly ERROR_MISSING_TRANSLATION = 'You are missing translation text';
	public static readonly ERROR_QUESTION_LIMIT =
		'You have exceeded the maximum number of {threshold} total ' +
		'questions, including survey & demographic questions, allowed on a survey. You will not be ' +
		'allowed to schedule your survey until you remove additional';
	public static readonly VALIDATION_MESSAGE_REQUIRED_FORM_FIELD = '{label} is required.';
	public static readonly VALIDATION_HIERARCHY_SELECTION_REQUIRED = 'Please select a hierarchy.';

	// Action Menu
	public static readonly ACTIONMENU_SECTION_GOTO = 'Go to';
	public static readonly ACTIONMENU_SECTION_COMMANDS = 'Commands';
	public static readonly ACTIONMENU_LINK_SURVEYREPORTING = 'Survey Reporting';
	public static readonly ACTIONMENU_LINK_SURVEYADMIN = 'Survey Admin';
	public static readonly ACTIONMENU_COMMAND_COPY = 'Copy';
	public static readonly ACTIONMENU_COMMAND_COPYSURVEY = 'Copy Survey';
	public static readonly ACTIONMENU_COMMAND_DELETE = 'Delete';
	public static readonly ACTIONMENU_COMMAND_RENAME = 'Rename';
	public static readonly ACTIONMENU_EDIT = 'Edit';
	public static readonly ACTIONMENU_VIEWEDIT = 'View / Edit';
	public static readonly ACTIONMENU_DELETE = 'Delete';
	public static readonly ACTIONMENU_SAVE = 'Save';
	public static readonly ACTIONMENU_APPENDLIST = 'Append List';
	public static readonly ACTIONMENU_SELECT_ACTIONS = 'Select Actions';
	public static readonly ACTIONMENU_CREATE_NEW = 'Create New';
	public static readonly ACTIONMENU_PICK_FROM_TEMPLATE = 'Pick From Template';
	public static readonly ACTIONMENU_ACTIVE = 'Active';
	public static readonly ACTIONMENU_TEST = 'Test';

	// ID's
	public static readonly ID_PARTICIPATION_MONITOR_ATTRIBUTES = 'participation-monitor-attributes';
	public static readonly ID_REPORTING_BENCHMARKS = 'reporting-benchmarks';
	public static readonly ID_REPORTING_HIERARCHY_SELECTION = 'reporting-hierearchy-selection';
	public static readonly ID_REPORTING_PROFILES = 'reporting-profiles';
	public static readonly ID_REPORTING_TRENDS = 'reporting-trends';
	public static readonly ID_REPORTING_USERS = 'reporting-users';
	public static readonly ID_RESPONSE_STREAMING = 'response-streaming';

	// DISPLAYLOGIC
	public static readonly DISPLAYLOGIC_DATA_MISSING_ERROR = 'DATA MISSING OR CHANGED:';
	public static readonly DISPLAYLOGIC_DATA_MISSING_SAVE_MESSAGE = 'Please save again to confirm the selections below.';
	public static readonly RANDOMIZED_ITEMS_BOX_MESSAGE = 'Questions that appear grouped together are set to randomize.';

	// DISTRIBUTION OPTIONS
	public static readonly DISTRIBUTIONOPTIONS_SINGLE_LINK_USER_DESCRIPTION =
		'Fast and simple. We provide you ' + 'with a link to the survey that you	send out to your survey	audience.';
	public static readonly DISTRIBUTIONOPTIONS_SINGLE_LINK_USER_TITLE = 'You Send';
	public static readonly DISTRIBUTIONOPTIONS_SINGLE_LINK_SYSTEM_DESCRIPTION =
		'A single link gets emailed out to each employee in your uploaded distribution list.';
	public static readonly DISTRIBUTIONOPTIONS_SINGLE_LINK_SYSTEM_TITLE = 'System Sends';
	public static readonly DISTRIBUTIONOPTIONS_UNIQUE_LINK_DESCRIPTION =
		'For companies that want individual ' + 'demographic tie-backs in their reporting.';
	public static readonly DISTRIBUTIONOPTIONS_UNIQUE_LINK_TITLE = 'Unique Link';
	public static readonly DISTRIBUTIONOPTIONS_SINGLE_LINK_WITH_ACCESS_CODES_DESCRIPTION =
		'Provide unique access codes to grant participants access to their survey.';
	public static readonly DISTRIBUTIONOPTIONS_SINGLE_LINK_WITH_ACCESS_CODES_TITLE = 'Access Codes';
	public static readonly ACCESS_CODE_TYPES_AUTOGENERATED = 'Autogenerated';
	public static readonly ACCESS_CODE_TYPES_CUSTOM = 'Custom';
	public static readonly DISTRIBUTIONOPTIONS_SSO_DESCRIPTION =
		'Grant participants Single Sign-On (SSO) privileges for seamless access to their surveys.';
	public static readonly DISTRIBUTIONOPTIONS_SSO_TITLE = 'SSO';
	public static readonly DISTRIBUTIONOPTIONS_WARNING_HEADLINE = 'Data will be deleted.';
	public static readonly DISTRIBUTIONOPTIONS_WARNING_BODY = `Your distribution type data will be deleted by navigating away from this section.`;
	public static readonly SELECT_AUDIENCE_SOURCE = 'Please select an employee data source in step 1 (Initial survey setup) to proceed';

	// SURVEY PARTICIPANTS
	public static readonly SURVEYPARTICIPANTS_PUBLISHING_NOTE =
		'<strong>NOTE:</strong> Survey participants are still being processed. Please check back in 5-10 minutes.';
	public static readonly SURVEY_PARTICIPANTS_ACTION_WARNING = `<strong>NOTE:</strong> The Reset survey action can only be applied to participants with the status of
		"Complete" or "In Progress". The Reopen survey action can only be applied to participants with the status "Complete".`;
	public static readonly SURVEY_PARTICIPANTS_DUPLICATE_EMAILS_WARNING_PREFIX = 'Two or more employees share the same email address.';
	public static readonly SURVEY_PARTICIPANTS_DUPLICATE_EMAILS_WARNING_UNIQUE =
		'If selected, each employee will receive a unique email with a link to their survey at the shared address.';
	public static readonly SURVEY_PARTICIPANTS_DUPLICATE_EMAILS_WARNING_SINGLELINK =
		'If selected, each employee will receive an email with a generic link at the shared address.';

	// DATEPICKER
	public static readonly DATEPICKER_CLEARTEXT = 'Clear Date';
	public static readonly DATEPICKER_OPEN_DATE = 'Open Date';
	public static readonly DATEPICKER_CLOSE_DATE = 'Close Date';
	public static readonly DATEPICKER_USE_DATES = 'Use Dates';

	// SURVEY ADMIN
	public static readonly SURVEY_ADMIN_ACTION_ADD_SUBTRACT_BENCHMARKS = 'Benchmarks';
	public static readonly SURVEY_ADMIN_ACTION_ADD_SUBTRACT_BENCHMARKS_READONLY = 'Benchmarks (Read only)';
	public static readonly SURVEY_ADMIN_ACTION_DISTRIBUTION_LIST = 'Distribution List';
	public static readonly SURVEY_ADMIN_ACTION_HEADER_RESET_REOPEN_RESEND = 'Reset, Resend, Reopen';
	public static readonly SURVEY_ADMIN_ACTION_EDIT_SURVEY = 'Edit Survey';
	public static readonly SURVEY_ADMIN_ACTION_CANCEL_SURVEY = 'Cancel Survey';
	public static readonly SURVEY_ADMIN_ACTION_MANAGE_DIMENSIONS = 'Manage Dimensions';
	public static readonly SURVEY_ADMIN_ACTION_CHANGE_OPEN_CLOSE_DATES = 'Open / Close Dates';
	public static readonly SURVEY_ADMIN_HEADER_CONTROL_PANEL = 'Survey Admin';
	public static readonly SURVEY_ADMIN_AUDIENCE_HEADER_CONTROL_PANEL = 'Audience Admin';
	public static readonly SURVEY_ADMIN_ACTION_DOWNLOAD_SURVEY_URLS_LIST = 'Download Survey URLs List';
	public static readonly SURVEY_ADMIN_ACTION_INVITE_EMAIL = 'Invite Email';
	public static readonly SURVEY_ADMIN_ACTION_RESET_REOPEN_RESEND = 'Reset Survey, Reopen Survey, Resend Invite';
	public static readonly SURVEY_ADMIN_ACTION_INVITE_EMAIL_READONLY = ContentConstants.SURVEY_ADMIN_ACTION_INVITE_EMAIL + ' (read-only)';
	public static readonly SURVEY_ADMIN_ACTION_PARTICIPATION_MONITOR = 'Participation Monitor';
	public static readonly SURVEY_ADMIN_ACTION_IMPORT_RETRY = 'Import Retry';
	public static readonly SURVEY_ADMIN_ACTION_PREVIEW_SURVEY = 'Preview Survey';
	public static readonly SURVEY_ADMIN_ACTION_MANAGE_DIMENSION_LIST = 'Manage Dimensions';
	public static readonly SURVEY_ADMIN_ACTION_MANAGE_DIMENSION_CREATE = 'Create Dimension';
	public static readonly SURVEY_ADMIN_ACTION_MANAGE_DIMENSION_EDIT = 'Edit Dimension';
	public static readonly SURVEY_ADMIN_ACTION_SURVEY_OVERVIEW = 'Survey Overview';
	public static readonly SURVEY_ADMIN_ACTION_REMINDER_EMAILS = 'Reminder Emails';
	public static readonly SURVEY_ADMIN_ACTION_REMINDER_EMAILS_READONLY = 'Reminder Emails (Read Only)';
	public static readonly SURVEY_ADMIN_ACTION_REPORTING_USERS = 'Reporting Users';
	public static readonly SURVEY_ADMIN_ACTION_REPORTING_USERS_READONLY = 'Reporting Users (Read Only)';
	public static readonly SURVEY_ADMIN_ACTION_TREND_TO = 'Trend To';
	public static readonly SURVEY_ADMIN_ACTION_TREND_TO_READONLY = 'Trend To (Read Only)';
	public static readonly SURVEY_ADMIN_ACTION_HIERARCHY_VIEW = 'Hierarchy View';
	public static readonly SURVEY_ADMIN_ACTION_ANONYMITY_THRESHOLD = 'Anonymity Threshold';
	public static readonly SURVEY_ADMIN_ACTION_REPORTING_PROFILES = 'Reporting Profiles';
	public static readonly SURVEY_ADMIN_ACTION_CANCEL_EVENT = 'Cancel Event';
	public static readonly SURVEY_ADMIN_ACTION_REOPEN_SURVEY = 'Re-Open Survey';

	public static readonly SURVEY_ADMIN_BENCHMARKS_DESCRIPTION =
		'Select benchmarks to compare your ' +
		'survey data against.  We have a large array of benchmarks including location-specific and ' +
		'industry-specific to choose from.';
	public static readonly SURVEY_ADMIN_CONTROL_PANEL_ACTIONS = 'Survey Administration';
	public static readonly SURVEY_ADMIN_AUDIENCE_CONTROL_PANEL_ACTIONS = 'Audience Administration';
	public static readonly SURVEY_ADMIN_INVITE_EMAIL_NOTE = 'Note:';
	public static readonly SURVEY_ADMIN_INVITE_EMAIL_NOTE_CONTENT =
		' The invite email has already been sent out, changes are no longer allowed.';
	public static readonly SURVEY_ADMIN_IS_CLOSED_NOTE = 'Note: ';
	public static readonly SURVEY_ADMIN_IS_CLOSED_CONTENT = 'The survey has closed, changes are no longer allowed.';
	public static readonly SURVEY_ADMIN_IS_CANCEL_NOTE = 'Note: ';
	public static readonly SURVEY_ADMIN_IS_CANCEL_CONTENT = 'The survey has been cancelled, changes are no longer allowed.';
	public static readonly SURVEY_ADMIN_OPEN_CLOSE = 'Survey Open / Close Dates';
	public static readonly SURVEY_ADMIN_OPEN_CLOSE_READONLY = 'Survey Open / Close (Read only)';
	public static readonly SURVEY_ADMIN_OPEN_CLOSE_INSTRUCTIONS =
		'These are the dates when your ' +
		'audience can take the survey. The invite email will be sent on the open date.  We recommend ' +
		'you plan for at least 7 days for your employees to complete the survey.';
	public static readonly SURVEY_ADMIN_OPEN_CLOSE_INSTRUCTIONS_READONLY =
		'<strong>Note:</strong> The survey has closed, changes are no longer allowed.';
	public static readonly SURVEY_ADMIN_SURVEY_REOPEN_INSTRUCTIONS = 'Your survey will reopen when a close date is selected';
	public static readonly SURVEY_CANCEL_CONTENT_READONLY =
		'<strong>Note:</strong> The survey has been cancelled, changes are no longer allowed.';
	public static readonly SURVEY_ADMIN_PARTICIPANTS_APPENDMODAL_INSTRUCTIONS =
		'Download the template, fill it out, then upload it. ' + 'After the upload, the new participants will be added to the main list.';
	public static readonly SURVEY_ADMIN_PARTICIPANTS_APPENDMODAL_TITLE = 'Add New Participants';
	public static readonly SURVEY_ADMIN_PARTICIPANTS_EXPORT = 'Download Name/Email List';
	public static readonly SURVEY_ADMIN_PROGRESS_CLOSE = 'Latest Event Close Date';
	public static readonly SURVEY_ADMIN_AUDIENCE_PROGRESS_CLOSE = 'Event Close Date';
	public static readonly SURVEY_ADMIN_PROGRESS_DASHDASH = '--';
	public static readonly SURVEY_ADMIN_PROGRESS_OPEN = 'Earliest Event Open Date';
	public static readonly SURVEY_ADMIN_AUDIENCE_PROGRESS_OPEN = 'Event Open Date';
	public static readonly SURVEY_ADMIN_PROGRESS_STATUS = 'Status';
	public static readonly SURVEY_ADMIN_PROGRESS_SUBTEXT_AFTER_CLOSE = '{survey_event} is closed';
	public static readonly SURVEY_ADMIN_PROGRESS_SUBTEXT_BEFORE_OPEN = 'until {survey_event} opens';
	public static readonly SURVEY_ADMIN_PROGRESS_SUBTEXT_BEFORE_CLOSE = 'until {survey_event} closes';
	public static readonly SURVEY_ADMIN_PROGRESS_SUBTEXT_NOTSCHEDULED = '{survey_event} not scheduled';
	public static readonly SURVEY_ADMIN_PROGRESS_SUBTEXT_CANCELLED = '{survey_event} has been cancelled';
	public static readonly SURVEY_ADMIN_PROGRESS_UNIT_SINGULAR = 'day';
	public static readonly SURVEY_ADMIN_PROGRESS_UNIT_PLURAL = 'days';
	public static readonly SURVEY_ADMIN_REMINDER_EMAIL_NOTE_CONTENT =
		' This reminder email has ' + 'already been sent out, changes are no longer allowed.';
	public static readonly SURVEY_ADMIN_SIDE_PAD_HEADER = 'Survey Progress';
	public static readonly SURVEY_ADMIN_AUDIENCE_SIDE_PAD_HEADER = 'Event Progress';
	public static readonly SURVEY_ADMIN_REPORTING_USERS_LOCKED_MESSAGE = `<strong>LOCKED:</strong> Because the survey is now closed,
		your hierarchies and profiles used for reporting are now locked as well. You can still edit the scope and comparisons below.
		You can add or delete employees and collaborators group access in these hierarchies and move employees and collaborators
		into different profiles in Org Manager.`;

	public static readonly SURVEY_ADMIN_REPORTING_PROFILES_LOCKED_MESSAGE = `<strong>REPORTING PROFILE LIVE:</strong> If a Reporting
		Profile live date has been reached, edits to Live Date are no longer allowed.`;

	public static readonly SURVEY_ADMIN_EDIT_SURVEY_LIVE_SURVEY_WARNING_PULLOUT_HEADING = 'Live Survey: ';
	public static readonly SURVEY_ADMIN_EDIT_SURVEY_LIVE_SURVEY_WARNING_PULLOUT_BODY =
		'Making edits to your survey will cause changes to the live version and potentially create discrepancies between people who have finished and not finished taking the survey.';

	public static readonly TOAST_ERROR_TITLE_SURVEY_SUMMARIES_NOT_FETCHED = 'Unable to get survey summaries!';
	public static readonly TOAST_ERROR_SURVEY_SUMMARIES_NOT_FETCHED =
		"Please go to the 'Confirm and Schedule' page to check if there is any validation errors";

	// SurveyList Page
	public static readonly SURVEYLIST_PAGE_TITLE = 'Survey List';
	public static readonly SURVEYLIST_INSTRUCTIONSTITLE = "Build your first survey! It's simple and easy.";
	public static readonly SURVEYLIST_INSTRUCTIONSTEXT =
		'From choosing your program to reviewing and launching your survey' +
		', we make it easy to create survey programs and administer them.';

	public static readonly SURVEY_COPY_MODAL_TITLE = 'Select Users';
	public static readonly SURVEY_COPY_MODAL_CONTENT = `Select the users you want to copy the survey to.
		 Reporting access rights will be automatically added to the selected users.`;
	public static readonly SURVEY_TEMPLATE_COPY_MODAL_TITLE = 'Select Template Survey';
	public static readonly SURVEY_TEMPLATE_COPY_MODAL_CONTENT = 'Pick a template survey from the list below and configure it to your needs.';

	// SURVEY NOTES
	public static readonly SURVEY_NOTE = 'Note';
	public static readonly SURVEY_NOTE_PLACEHOLDER = 'Enter your note text here';

	public static readonly BRANDING_AND_THEME = {
		SURVEY_PREVIEW_MODAL: { TITLE: 'Preview' },
	} as const;

	public static readonly LOGIC_AND_LAYOUT = {
		NO_QUESTIONS_TITLE: 'This step is currently not available.',
		NO_QUESTIONS_BODY_PART_ONE: 'You do not have any questions added to the survey yet. ',
		NO_QUESTIONS_HYPERLINK_TEXT: 'Go to Define Survey Content step',
		NO_QUESTIONS_BODY_PART_TWO: ' and add questions to enable this step.',
		ADD_PAGE_BREAK: 'Add Page Break',
		EDIT_PAGE_BREAK: 'Edit Page Break',
		ADD_SECTION_BREAK: 'Add Section Break',
		EDIT_SECTION_BREAK: 'Edit Section Break',
		ADD_SECTION_HEADER: 'Add Section Header',
		EDIT_SECTION_HEADER: 'Edit Section Header',
		ADD_DESCRIPTION_TEXT: 'Add Text',
		EDIT_DESCRIPTION_TEXT: 'Edit Text',
		PAGE_BREAK: 'Page Break',
		SECTION_HEADER: 'Section Header',
		SECTION_HEADER_PLACEHOLDER: 'Enter Section Header',
		DESCRIPTION_TEXT: 'Enter Text',
		SECTION_BREAK: 'Section Break',
		TEXT: 'Text',
		QUESTIONS: 'Questions',
		BEFORE_QUESTION: 'Before Question',
		SELECT_QUESTION: 'Select Question',
		SELECT_INCREMENT: 'Select Increment',
		END_OF_SURVEY: 'End of Survey',
		AFTER_EVERY: 'After Every',
		QUESTION_ERROR_MESSAGE: 'You must select a Question',
		SECTION_HEADER_ERROR_MESSAGE: 'You must enter a Section Header',
		DESCRIPTION_TEXT_ERROR_MESSAGE: 'You must enter some text.',
		RANDOMIZE_SWITCH_TEXT: 'Randomize Questions',
		GROUP_QUESTION_LOGIC: {
			TITLE: 'Group Question Logic',
			QUESTIONS: {
				LABEL: 'Select Questions',
				DESCRIPTION: 'Select the questions that you want to apply logic to',
				SEARCH_PLACEHOLDER: 'Search',
			},
		},
	} as const;

	// CONFIRM & SCHEDULE
	public static readonly CONFIRMSCHEDULE_PAGE_TITLE = 'Confirm and Schedule';
	public static readonly CONFIRMSCHEDULE_ERROR_HEADER = 'Errors';
	public static readonly CONFIRMSCHEDULE_ERROR_LABEL = 'Error List';
	public static readonly CONFIRMSCHEDULE_ERROR_DESCRIPTION =
		'All the errors in the list below <strong>must be ' + 'resolved</strong> before you are allowed to preview and schedule your survey.';
	public static readonly CONFIRMSCHEDULE_FINALCONFIRMATION_TITLE = 'Final Confirmation';
	public static readonly CONFIRMSCHEDULE_FINALCONFIRMATION_LEAD = "You're almost done!";
	public static readonly CONFIRMSCHEDULE_FINALCONFIRMATION_BODY =
		'Please be aware that by proceeding, ' +
		'your survey will be officially scheduled and some of your survey choices, <strong>like your questions</strong>, ' +
		'will be permanently locked. Are you sure you wish to continue?';
	public static readonly CONFIRMSCHEDULE_SUMMARY_HEADER = 'Summary';
	public static readonly CONFIRMSCHEDULE_BUTTON_PREVIEWSURVEY = 'Preview Survey';
	public static readonly CONFIRMSCHEDULE_REPORTING_HEADER = 'Survey Reporting';
	public static readonly CONFIRMSCHEDULE_PREVIEW_CALLOUT = 'PREVIEW SURVEY:';
	public static readonly CONFIRMSCHEDULE_PREVIEW_CALLOUT_TEXT = `Previewing the survey will open a tab with a generic survey for general testing. If you have a Test Audience with a distribution list, it will take about 5-10 minutes to finish processing and sending out the emails to test your survey.`;

	// AudienceList Page
	public static readonly AUDIENCELIST_NOAUDIENCE_INSTRUCTIONSTITLE = 'Add an audience for survey distribution.';
	public static readonly AUDIENCELIST_NOAUDIENCE_INSTRUCTIONSTEXT = `This is the audience you want to distribute your survey to.
		After you add your survey audience
		a table will represent them and their survey open / close dates.`;
	public static readonly AUDIENCELIST_NOAUDIENCESOURCE_INSTRUCTIONSTITLE = 'Distribution is currently not available.';
	public static readonly AUDIENCELIST_NOAUDIENCESOURCE_INSTRUCTIONSTEXT = `Distribution is currently not availiable
		because you did not complete the <strong>Employee Data Source</strong> section in <strong>Initial Survey Setup step</strong>. `;
	public static readonly AUDIENCELIST_NOAUDIENCESOURCE_INSTRUCTIONSLINKTEXT = 'Go back to Initial Survey Setup step ';
	public static readonly AUDIENCELIST_NOAUDIENCESOURCE_INSTRUCTIONSTEXT2 = 'and complete the section to enable this step.';

	// Audience Details Page
	public static readonly AUDIENCEDETAILS_ADD_PAGE_TITLE = 'Add Survey Audience';
	public static readonly AUDIENCEDETAILS_EDIT_PAGE_TITLE = 'Edit Survey Audience';
	public static readonly AUDIENCEDETAILS_NAME_SECTION_LABEL = 'Name of Audience';
	public static readonly AUDIENCE_TIMEZONE_SECTION_LABEL = 'Time Zone';
	public static readonly AUDIENCE_ERROR_NAME = 'Audience Name is required.';
	public static readonly AUDIENCE_ERROR_DISTRIBUTION_TYPE = 'Please select a distribution option and fill out the forms.';
	public static readonly AUDIENCE_ERROR_EMAIL_TEMPLATE_NAME = 'Please enter name of reminder email.';
	public static readonly AUDIENCE_ERROR_EMAIL_TEMPLATE_FROM = 'Please enter From email address.';
	public static readonly AUDIENCE_ERROR_EMAIL_TEMPLATE_REPLYTOEMAIL = 'Please enter ReplyTo email address.';
	public static readonly AUDIENCE_ERROR_INVITE_EMAIL_SUBJECT = 'Please enter subject line of the invite email.';
	public static readonly AUDIENCE_ERROR_REMINDER_EMAIL_SUBJECT = 'Please enter subject line of the invite email.';
	public static readonly AUDIENCE_ERROR_REMINDER_EMAIL_DUPLICATE_NAME =
		'Name of this reminder is a duplicate. Please enter a different name.';
	public static readonly AUDIENCE_ERROR_INVITE_EMAIL_CONTENT = 'Please enter content of reminder email.';
	public static readonly AUDIENCE_ERROR_REMINDER_EMAIL_CONTENT = 'Please enter content of reminder email.';
	public static readonly AUDIENCE_ERROR_NO_EMAIL_ADDRESSES = 'Please enter an email address where you want to receive a test email.';
	public static readonly AUDIENCE_ERROR_INVALID_EMAIL_ADDRESSES =
		'There are invalid email address(es), please correct them before sending test email.';
	public static readonly AUDIENCE_ERROR_EXCEED_EMAIL_ADDRESS_LIMIT =
		'You have exceeded the limit of {limit} email addresses, please correct them before sending test email.';
	public static readonly AUDIENCE_ERROR_SURVEY_LINK_NOT_EXIST = 'You must include at least one survey link in your email content.';
	public static readonly AUDIENCE_ERROR_OPENDATE_GREATER_THAN_CLOSEDATE = 'Open date should be a previous date to Close date.';
	public static readonly AUDIENCE_ERROR_INVALID_OPENDATE = 'You have an invalid open date, please update and save the changes.';
	public static readonly AUDIENCE_ERROR_INVALID_CLOSEDATE = 'You have an invalid close date, please update and save the changes.';
	public static readonly AUDIENCE_ERROR_INVALID_OPENDATE_AND_CLOSEDATE =
		'You have invalid open and close dates, please update and save the changes.';
	public static readonly AUDIENCE_ERROR_EMAIL_CONTENT_TOO_LARGE = 'Email content cannot exceed 500KB.';
	public static readonly ENTER_VALUE_REQUIRED = 'Please enter a value.';
	public static readonly SELECT_VALUE_REQUIRED = 'Please select a value.';
	public static readonly AUDIENCE_OPENCLOSEDATES_OPENIMMEDIATELY = 'Immediately';
	public static readonly AUDIENCE_OPENCLOSEDATES_TITLE = 'Audience Open / Close Dates';
	public static readonly AUDIENCE_OPENIMMEDIATELY_TOGGLE = 'Open immediately upon survey setup completion';
	public static readonly AUDIENCE_PUBLISH_GENERICERROR = 'An issue occurred processing the audience.';
	public static readonly AUDIENCE_NOT_PUBLISHED = 'Audience has not been scheduled.';

	// DISTRIBUTION
	public static readonly DISTRIBUTIONOPTIONS_PAGE_TITLE = 'Edit Survey Audience';
	public static readonly REMINDER_EMAIL_SECTION_TITLE = 'Reminder Emails';
	public static readonly REMINDER_EMAIL_CREATE_NEW = 'Create Reminder Email';
	public static readonly DISTRIBUTIONLIST_TITLE = 'Distribution List';
	public static readonly ACCESS_CODES_TITLE = 'Access Codes:';
	public static readonly ACCESS_CODES_BODY = 'Provide unique access codes to grant participants access to their survey.';
	public static readonly DISTRIBUTION_VALUE_REQUIRED = 'Please upload a completed distribution list.';
	public static readonly DISTRIBUTION_APPENDMODAL_TITLE = 'Add Appended List';
	public static readonly DISTRIBUTION_APPENDMODAL_INSTRUCTIONS =
		"If you haven't yet, download the template, fill it out, then upload it using this interface.\r \n" +
		'After the upload, the new employees will be added to the main list.';

	// REPORTING ACCESS
	public static readonly PLACEHOLDER_REPORTING_FIRSTNAME = 'First Name';
	public static readonly PLACEHOLDER_REPORTING_LASTNAME = 'Last Name';
	public static readonly PLACEHOLDER_REPORTING_EMAIL = 'Email';
	public static readonly PLACEHOLDER_REPORTING_ADD_USER = 'Add new user for reporting access';
	public static readonly PLACEHOLDER_REPORTING_ERROR_ENTER_VALUE = 'Please enter a value.';
	public static readonly PLACEHOLDER_REPORTING_ERROR_SELECT_VALUE = 'Please select a value.';
	public static readonly PLACEHOLDER_REPORTING_ERROR_ENTER_EMAIL = 'Please enter a valid email.';
	public static readonly PLACEHOLDER_REPORTING_ERROR_ENTER_UNIQUE_EMAIL = 'Please enter a unique email.';
	public static readonly REPORTING_MIN_N_OVERRIDE = 'Override Threshold';
	public static readonly REPORTING_NO_BENCHMARKS_SELECTED = 'You have no enabled benchmarks.';
	public static readonly PLACEHOLDER_REPORTING_ERROR_TOO_MANY =
		"You've exceeded the maximum of 50 users for reporting. " +
		'You will not be allowed to schedule your survey until you remove some of the users.';
	public static readonly PLACEHOLDER_REPORTING_ERROR_TOO_MANY_ADMIN =
		"You've exceeded the maximum of 50 users for reporting. " + 'You will not be allowed to save until you remove some of the users.';
	public static readonly REPORTING_NO_TREND_SURVEYS = 'You have no previous surveys for trending.';
	public static readonly REPORTING_TRENDS_PREVIOUS_SURVEYS_LABEL = 'Previous Surveys';
	public static readonly REPORTINGTREND_VALIDATE_TRENDGROUP = 'SelectedTrendGroupId';
	public static readonly REPORTINGUSER_VALIDATE_FIRSTNAME = 'FirstName';
	public static readonly REPORTINGUSER_VALIDATE_LASTNAME = 'LastName';
	public static readonly REPORTINGUSER_VALIDATE_EMAILADDRESS = 'EmailAddress';
	public static readonly TABLE_HEADER_REPORTING_DESCRIPTION = 'DESCRIPTION';
	public static readonly TABLE_HEADER_REPORTING_EMAIL = 'EMAIL';
	public static readonly TABLE_HEADER_REPORTING_FIRSTNAME = 'FIRST NAME';
	public static readonly TABLE_HEADER_REPORTING_LASTNAME = 'LAST NAME';
	public static readonly TABLE_HEADER_REPORTING_MATCHINGDIMENSIONS = 'MATCHING DIMENSIONS';
	public static readonly TABLE_HEADER_REPORTING_MATCHINGQUESTIONS = 'MATCHING QUESTIONS';
	public static readonly TABLE_HEADER_REPORTING_NAME = 'NAME';
	public static readonly TABLE_HEADER_REPORTING_SURVEYNAME = 'SURVEY NAME';
	public static readonly REPORTING_USERS_MESSAGE_PROFILE_INVALID_GO_LIVE_DATE =
		'<strong>ACTION NEEDED:</strong> You have added new profiles ({InvalidProfileNames}). ' +
		'Please go to <strong>Reporting Profiles</strong> and set a <strong>reporting site go live date' +
		'</strong> to fully enable these newly added profiles.';

	// HIERARCHY REPORTING ACCESS CONFIG TABLE
	public static readonly HIERARCHY_REPORTING_ACCESS_TABLE_HEADER_HIERARCHY = 'HIERARCHY';
	public static readonly HIERARCHY_REPORTING_ACCESS_TABLE_HEADER_REPORTING_USERS_COUNT = 'REPORTING USERS';
	public static readonly HIERARCHY_REPORTING_ACCESS_TABLE_HEADER_PROFILES = 'PROFILES';
	public static readonly HIERARCHY_REPORTING_ACCESS_TABLE_HEADER_SCOPEGROUPS = 'DATA SCOPE';
	public static readonly HIERARCHY_REPORTING_ACCESS_TABLE_HEADER_ACTIONS = 'ACTIONS';
	public static readonly HIERARCHY_REPORTING_ACCESS_TABLE_ACTION_EDIT = 'Edit';
	public static readonly HIERARCHY_REPORTING_ACCESS_TABLE_ACTION_DELETE = 'Delete';

	// HIERARCHY REPORTING ACCESS CONFIG MODAL
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_ADD_TITLE = 'Add Reporting Users';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_EDIT_TITLE = 'Edit Reporting Users';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_ADD_BUTTON = 'Add Access';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_SAVE_BUTTON = 'Save';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_SAVE_AND_CLOSE_BUTTON = 'Save And Close';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_HIERARCHY_SELECT_LABEL =
		'I want individuals with group access in this hierarchy';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_HIERARCHY_SELECT_PLACEHOLDER = 'Select a hierarchy';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_PROFILE_SELECT_LABEL = 'and to have the profile of';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_PROFILE_SELECT_PLACEHOLDER = 'Select group access profiles';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_SCOPE_SELECT_LABEL = 'to have the survey results (scope) of';
	public static readonly HIERARCHY_REPORTING_ACCESS_CONFIG_MODAL_SCOPE_SELECT_PLACEHOLDER = 'Select data scope';

	// Reporting Profile Configs table
	public static readonly REPORTING_PROFILES_LABEL = 'Profiles';
	public static readonly REPORTING_PROFILES_DESCRIPTION =
		'<strong>Use the actions column</strong> to schedule the invite email and add / remove reporting filter and segments. ' +
		'These are profiles that were defined in Org Manager for employees with group access.';
	public static readonly REPORTING_PROFILES_MESSAGE_INVALID_GO_LIVE_DATE =
		'<strong>ACTION NEEDED:</strong> You have added new profiles ({InvalidProfileNames}). ' +
		'Please click <strong>Actions</strong> and set a <strong>reporting site go live date</strong> to fully enable these newly added profiles.';
	public static readonly REPORTING_PROFILES_TABLE_HEADER_PROFILE_NAME = 'Profile Name';
	public static readonly REPORTING_PROFILES_TABLE_HEADER_REPORTING_USERS_COUNT = 'Reporting Users';
	public static readonly REPORTING_PROFILES_TABLE_HEADER_GO_LIVE_DATE = 'Reporting Site Go Live Date';
	public static readonly REPORTING_PROFILES_TABLE_HEADER_FILTERS_SEGMENTS = 'Reporting Filters / Segments';
	public static readonly REPORTING_PROFILES_TABLE_HEADER_DEFAULT_HIERARCHY = 'Default Hierarchy';
	public static readonly REPORTING_PROFILES_TABLE_HEADER_ACTIONS = 'Actions';

	public static readonly REPORTING_PROFILES_TABLE_ACTION_EDIT_GO_LIVE_INVITE = 'Edit reporting site go live date, invite email';

	public static readonly REPORTING_PROFILES_TABLE_IMMEDIATELY_ON_SURVEY_CLOSE = 'Immediately upon survey close';

	public static readonly REPORTING_PROFILES_TABLE_EDIT_MODAL_DATE_PICKER_PLACEHOLDER = 'Select date / time';
	public static readonly REPORTING_PROFILES_TABLE_EDIT_MODAL_GO_LIVE_DATE_DESCRIPTION =
		'This is the time / date the invite email will be sent and the reporting site will go live.';
	public static readonly REPORTING_PROFILES_TABLE_EDIT_MODAL_GO_LIVE_DATE_LABEL = 'Go Live Date';
	public static readonly REPORTING_PROFILES_TABLE_EDIT_MODAL_INVITE_TITLE = 'Edit Go Live Date, Invite Email';
	public static readonly REPORTING_PROFILES_TABLE_EDIT_MODAL_SAVE_AND_CLOSE_BUTTON = 'Save And Close';
	public static readonly REPORTING_PROFILES_TABLE_EDIT_MODAL_SAVE_BUTTON = 'Save';
	public static readonly REPORTING_PROFILES_TABLE_EDIT_MODAL_TIME_ZONE_LABEL = 'Time Zone';

	// GroupType enum
	public static readonly GROUPTYPE_THEIRGROUPONLY = 'Their group only';
	public static readonly GROUPTYPE_THEIRGROUPANDALLBELOW = 'Their group and all below';
	public static readonly GROUPTYPE_THEIRROLLUPSONLY = 'Their rollups only';
	public static readonly GROUPTYPE_THEIRROLLUPSANDALLBELOW = 'Their rollups and all below';

	// Distribution Contacts
	public static readonly DISTRIBUTION_CONTACTS_MODAL_TITLE = 'View / Edit Distribution List';
	public static readonly DISTRIBUTION_CONTACTS_MODAL_TITLE_READONLY = 'View Distribution List';
	public static readonly DISTRIBUTION_CONTACTS_SHOW_DUPLICATE_EMAILS_TOGGLE_LABEL = 'Show duplicate email addresses';

	// PARTICIPATION MONITOR
	public static readonly PARTICIPATION_MONITOR_COMPLETED = 'Completed';
	public static readonly PARTICIPATION_MONITOR_INVITED = 'Invited';
	public static readonly PARTICIPATION_MONITOR_PARTIAL_COMPLETES = 'Partial Completes';
	public static readonly PARTICIPATION_MONITOR_DATA_AS_OF = 'Data As Of';
	public static readonly PARTICIPATION_MONITOR_INCLUDE_PARTIAL_COMPLETES = 'Include Partial Completes';
	public static readonly PARTICIPATION_MONITOR_COMPLETION_PERCENTAGE = 'Completion Percentage';
	public static readonly SIGNALR_PARTICPANT_MONITOR_COUNTS_CHANGED = 'Participation counts have been updated.';

	// Question Filters
	public static readonly FILTER_BENCHMARKS = 'Benchmarks';
	public static readonly FILTER_LANGUAGES = 'Languages';
	public static readonly FILTER_QUESTION_TEMPLATES = 'Question Templates';
	public static readonly FILTER_RESPONSE_OPTION_GROUPS = 'Response Option Groups';
	public static readonly FILTER_TAGS = 'Tags';

	public static readonly SURVEY_QUESTIONS_TOOLTIP_TITLE_TEXT =
		'Click this button to see all the alternative versions ' + 'of the questions below.';

	// SURVEY PARTICIPANTS
	public static readonly SURVEY_PARTICIPANT_REOPEN_RESEND_CHECKBOX_LABEL = 'Resend email after reopening survey';
	public static readonly SURVEY_PARTICIPANT_RESET_RESEND_CHECKBOX_LABEL = 'Resend email after resetting survey';

	public static readonly SECTION_HEADERS_MANAGE_DIMENSIONS = 'Manage Dimensions';

	// Hierarchy
	public static readonly GROUP_BASED_LINKS_USER_HEADLINE = 'Group based links';
	public static readonly GROUP_BASED_LINKS_USER_DESCRIPTION =
		'Our system generates a unique link ' + "for each group/node in the hierarchy. Then it's up to you to send out the links.";
	public static readonly GROUP_BASED_LINKS_DISTRIBUTION_NOTE_CONTENT =
		': The list of survey URLs per node will be available only after you schedule ' + 'your survey in the ';

	// AUDIENCE SOURCE TYPE
	public static readonly AUDIENCE_SOURCE_CHOOSE_YOUR_SOURCE = 'Choose Your Source';
	public static readonly AUDIENCE_SOURCE_EMPLOYEE_FILE = 'Employee File (With Hierarchies)';
	public static readonly AUDIENCE_SOURCE_HIERARCHY_STRUCTURE = 'Hierarchy Structure';
	public static readonly AUDIENCE_SOURCE_OTHER_SOURCE = 'Other Source';
	public static readonly AUDIENCE_SOURCE_EMPLOYEE_FILE_TOOLTIP = `Employee files that have been uploaded in Org Manager and
		have hierarchies built from it. By using this data source you will have the full range of options throughout
		Survey Builder, including question branching based on both employee attributes and hierarchies.`;
	public static readonly AUDIENCE_SOURCE_HIERARCHY_STRUCTURE_TOOLTIP = `Hierarchy only files that have been uploaded in Org Manager.
		These files have no employee data; they're only used to derive a hierarchy. You only have 1 distribution type:
		Group based links.`;
	public static readonly AUDIENCE_SOURCE_OTHER_SOURCE_TOOLTIP = `An uploaded distribution list (uploaded at the Distribute Your Survey
		step) or no data source. By using this data source you will have a limited range of options throughout Survey Builder,
		included limited question branching options.`;

	// Distribution Types
	public static readonly DISTRIBUTIONTYPE_SINGLELINK_WITHOUTDISTRIBUTION = 'A single link you send';
	public static readonly DISTRIBUTIONTYPE_SINGLELINK = 'A single link our system sends';
	public static readonly DISTRIBUTIONTYPE_SINGLELINK_WITHACCESSCODE = 'A single link with access code our system sends';
	public static readonly DISTRIBUTIONTYPE_UNIQUE = 'Unique link for each employee';
	public static readonly DISTRIBUTIONTYPE_GROUPBASEDLINKS = 'Group based links';
	public static readonly DISTRIBUTIONTYPE_SSO = 'SSO';

	// reporting users disabled
	public static readonly REPORTINGUSER_SECTION_DISABLED_HEADER = 'This option is not currently available';
	public static readonly REPORTINGUSER_SECTION_DISABLED_BODY =
		'This option is not currently available because your distribution type uses a single link.' +
		" <a href='{audience_url}'>Go back to " +
		ContentConstants.STEPPER_STEP_DISTRIBUTION +
		'</a> and change your distriubtion' +
		' type to <strong>' +
		ContentConstants.DISTRIBUTIONTYPE_UNIQUE +
		'</strong> to enable this option.';

	// No access modal
	public static readonly NO_ACCESS_MODAL_TITLE = 'Error';
	public static readonly NO_ACCESS_MODAL_MESSAGE = `You do not have any access to any client,
		please contact your support team.`;

	// Text to speech
	public static readonly SURVEY_TEXT_TO_SPEECH_INSTRUCTIONS_PROPERTY_DISPLAYNAME = 'Survey Text To Speech Instructions';
	public static readonly SURVEY_TEXT_TO_SPEECH_UNSUPPORTED_LANGUAGES_WARNING =
		'You have languages ({UnsupportedLanguages}) that are not supported by the Text As Audio feature.';

	// Question changes
	public static readonly QUESTION_CHANGES_UPDATE_ALL = 'Update All';
	public static readonly QUESTION_CHANGES_VIEW_UPDATE = 'View Update';
	public static readonly QUESTION_CHANGES_MODAL_TITLE = 'Update Details';
	public static readonly QUESTION_CHANGES_UPDATE_AVAIABLE_TEXT = 'Update Available';
	public static readonly QUESTION_CHANGES_MODAL_CONTENT_TITLE = 'Question Updated in Question Library';
	public static readonly QUESTION_CHANGES_MODAL_CONTENT_PRETEXT = 'The following changes are made to this question in Question Library:';
	public static readonly WARNING_QUESTION_HAS_UPDATES =
		'<b>One or more</b> question(s) on your survey have been updated in Question Library. ' +
		'You could choose to manually update each question on your survey individually or update all at ' +
		'once.  However, if you remove and reselect a question on our survey, you will automatically ' +
		'get the most updated version of the question.';
	public static readonly QUESTION_CHANGES_TEXT_CHANGED = 'Question text has been updated to "{text}"';
	public static readonly QUESTION_CHANGES_QUESTION_TRANSLATIONS_ADDED = 'Question translations added for ' + '{translations}';
	public static readonly QUESTION_CHANGES_QUESTION_TRANSLATIONS_DELETED = 'Question translations deleted for ' + '{translations}';
	public static readonly QUESTION_CHANGES_QUESTION_TRANSLATIONS_UPDATED = 'Question translations updated for ' + '{translations}';
	public static readonly QUESTION_CHANGES_RESPONSE_OPTION_GROUP = 'Response Option Group has been updated to ';
	public static readonly QUESTION_CHANGES_RESPONSE_OPTIONS = 'Response Options have been updated to:';
	public static readonly QUESTION_CHANGES_RESPONSE_OPTION_TRANSLATIONS_ADDED = 'Question translations added for ' + '{translations}';
	public static readonly QUESTION_CHANGES_RESPONSE_OPTION_TRANSLATIONS_DELETED = 'Question translations deleted for ' + '{translations}';
	public static readonly QUESTION_CHANGES_RESPONSE_OPTION_TRANSLATIONS_UPDATED = 'Question translations updated for ' + '{translations}';
	public static readonly QUESTION_CHANGES_FOLLOW_UP = 'A Follow-up text box was changed for the response option group';

	public static readonly QUESTION_TYPE_RADIO_BUTTON = 'Radio Button';
	public static readonly QUESTION_TYPE_SLIDER = 'Slider';
	public static readonly QUESTION_TYPES_DROPDOWN_PLACEHOLDER = 'Select an Option';
	public static readonly QUESTION_TYPES_HELP_TEXT = '<b>Set all</b>&nbsp;Question Types to:&nbsp;';
	public static readonly SELECT_ALL_RESPONSE_REQUIRED = '<b>Select all</b>&nbsp;Response Required&nbsp;';

	// MULTIPLE TOGGLE
	public static readonly RESPONSE_OPTION_GROUP_TOGGLE_LABEL = 'Multiple Answers';
	public static readonly RESPONSE_OPTION_GROUP_TOGGLE_TOOLTIP =
		'This question will allow multiple response options to be selected when enabled.';

	// Ranking Toggle
	public static readonly RESPONSE_OPTION_GROUP_RANKING_TOGGLE_LABEL = 'Ranking';
	public static readonly RESPONSE_OPTION_GROUP_RANKING_TOGGLE_TOOLTIP =
		'Create response options that can be ordered from greatest to least importance by survey takers';
}
